import React, { createContext, useContext, useState } from "react";
import api from "./api";

const dict = {
  es: {
    "brand.name": "KYCFEDERAL",
    "brand.tagline": "Identity Verification Solutions",
    "nav.dashboard": "Panel principal",
    "nav.sanctions": "OFAC-ONU-GAFI",
    "nav.pep": "PEP y RCA",
    "nav.blacklist": "Lista Negra (BL) Privada",
    "bl.title": "Lista Negra (BL)",
    "bl.clear_sel": "Limpiar selección",
    "bl.photo": "Foto del sujeto", "bl.doc_cedula": "Cédula", "bl.doc_pasaporte": "Pasaporte", "bl.doc_licencia": "Licencia",
    "bl.upload_ph": "Seleccionar archivo…",
    "bl.subtitle": "Personas naturales, empresas y proveedores bloqueados o restringidos por su organización. Se verifica automáticamente en cada búsqueda de debida diligencia, igual que las listas OFAC y CSNU.",
    "bl.new": "Agregar registro", "bl.type": "Tipo",
    "bl.t_person": "Persona natural", "bl.t_company": "Empresa", "bl.t_supplier": "Proveedor",
    "bl.name": "Nombre completo o razón social", "bl.id_number": "Cédula o pasaporte", "bl.ruc": "RUC",
    "bl.directors": "Directivos vinculados", "bl.dir_name": "Nombre", "bl.dir_id": "Cédula o pasaporte", "bl.dir_position": "Cargo",
    "bl.reason": "Motivo del bloqueo", "bl.inclusion_date": "Fecha de inclusión",
    "bl.status": "Estado", "bl.active": "Activo", "bl.inactive": "Inactivo",
    "bl.registered_by": "Registrado por", "bl.updated_by": "Actualizado por",
    "bl.deactivate": "Desactivar", "bl.activate": "Activar", "bl.edit": "Editar",
    "bl.saved": "Registro agregado a la lista negra", "bl.updated": "Registro actualizado",
    "bl.search_ph": "Buscar en lista negra…", "bl.documents": "Documentos de respaldo",
    "nav.forms": "Formularios DD",
    "nav.dd_natural": "DD Persona Natural",
    "nav.dd_juridica": "DD Persona Jurídica",
    "nav.declaracion": "Declaración de Fondos",
    "nav.certificacion": "Beneficiario Final",
    "nav.pep_panama": "Lista PEP Panamá",
    "pp.title": "Lista PEP Panamá",
    "pp.subtitle": "Personas Expuestas Políticamente de la República de Panamá. Lista administrada por el super administrador; se consulta automáticamente en cada búsqueda PEP.",
    "pp.add": "Agregar registro", "pp.edit": "Editar registro", "pp.import": "Importar Excel",
    "pp.source_ph": "Fuente (ej. Asamblea Nacional)",
    "pp.col_budget": "Partida", "pp.col_salary": "Salario",
    "pp.template": "Descargar plantilla",
    "pp.bulk_delete": "Borrado masivo", "pp.bulk_scope": "Alcance del borrado",
    "pp.bulk_scope_all": "— Toda la lista —",
    "pp.bulk_warn": "Se eliminarán permanentemente todos los registros del alcance seleccionado. Esta acción no se puede deshacer.",
    "pp.bulk_confirm": "Eliminar registros", "pp.bulk_deleted": "registros eliminados",
    "pp.cargo_all": "Todos los cargos", "pp.cargo_diputados": "Diputados",
    "pp.cargo_ministros": "Ministro", "pp.cargo_viceministros": "Viceministros",
    "pp.cargo_directores": "Directores", "pp.cargo_jefes": "Jefes",
    "pp.cargo_administradores": "Administradores",
    "pp.empty_prompt": "Realice una consulta para ver los registros de la lista.",
    "pp.clear_sel": "Limpiar selección",
    "pp.search_ph": "Buscar por nombre, cédula, cargo o institución",
    "pp.col_name": "Nombre completo", "pp.col_id": "Cédula / Pasaporte", "pp.col_position": "Cargo",
    "pp.col_institution": "Institución", "pp.col_organ": "Órgano del Estado", "pp.col_period": "Periodo",
    "pp.col_obs": "Observaciones", "pp.current": "Activo", "pp.empty": "Sin registros en la lista",
    "pp.confirm_delete": "¿Eliminar este registro de la Lista PEP Panamá?",
    "pp.imported": "registros importados", "pp.saved": "Registro guardado", "pp.deleted": "Registro eliminado",
    "pp.f_start": "Fecha de inicio del cargo", "pp.f_end": "Fecha de fin del cargo",
    "pp.f_current": "Actualmente en ejercicio (activo)",
    "pp.badge": "Lista PEP Panamá",
    "nav.dd_aseguradora": "DD PN Aseguradora",
    "a.title": "DD Persona Natural — Aseguradora",
    "a.subtitle": "Formulario de cumplimiento BC/FT/FPADM según Acuerdo No. 3 del 22 de noviembre de 2022. Documento genérico, reutilizable por cualquier aseguradora.",
    "a.sec0": "Persona que completa", "a.sec1": "Datos generales", "a.sec2": "Persona Expuesta Políticamente (PEP)",
    "a.sec3": "Perfil financiero", "a.sec4": "Datos laborales", "a.sec5": "Consentimiento",
    "a.sec6": "Firmas", "a.sec7": "Documentos requeridos",
    "a.completed_by": "La persona que completa este formulario es (selección múltiple):",
    "a.cb_contractor": "Contratante", "a.cb_insured": "Asegurado", "a.cb_broker": "Corredor",
    "a.cb_payer": "Pagador", "a.cb_insurer": "Cía. de Seguros", "a.cb_beneficiary": "Beneficiario",
    "a.last_name_p": "Apellido (1er)", "a.last_name_m": "Apellido (2do)",
    "a.first_name": "Nombre (1er)", "a.second_name": "Nombre (2do)",
    "a.birth_date": "Fecha de nacimiento", "a.birth_country": "País de nacimiento",
    "a.nationality": "Nacionalidad", "a.residence_country": "País de residencia", "a.gender": "Sexo",
    "a.id_number": "Cédula", "a.passport": "Pasaporte",
    "a.addr_res": "Dirección residencial", "a.addr_work": "Dirección laboral",
    "a.addr_country": "País", "a.addr_province": "Provincia", "a.addr_district": "Distrito",
    "a.addr_corregimiento": "Corregimiento", "a.addr_urb": "Urbanización", "a.addr_street": "Calle",
    "a.addr_building": "Nombre de edificio", "a.addr_apt": "# de apartamento o casa",
    "a.mobile": "Celular", "a.home_phone": "Teléfono residencial", "a.email": "Correo electrónico",
    "a.tax_places": "Lugar(es) donde tributa por sus ingresos", "a.nit": "Número de identificación tributario (NIT)",
    "a.is_pep": "¿Es usted un PEP?", "a.pep_position": "Cargo actual o anterior",
    "a.is_pep_relative": "¿Es usted un familiar de un PEP?", "a.is_pep_collab": "¿Es usted un estrecho colaborador de un PEP?",
    "a.pep_name": "Nombre del PEP", "a.pep_rel_position": "Cargo del PEP", "a.pep_relation": "Relación con el PEP",
    "a.annual_income": "Ingreso anual aproximado (balboas)",
    "a.r1": "Menos de 10 mil", "a.r2": "10 mil a 30 mil", "a.r3": "30 mil a 50 mil", "a.r4": "Más de 50 mil",
    "a.other_income_desc": "Si genera ingresos por otra actividad — descripción",
    "a.other_income_amount": "Monto aproximado de la otra actividad",
    "a.profession": "Profesión", "a.occupation": "Ocupación", "a.employer": "Nombre de la empresa",
    "a.independent": "En caso de ser independiente o comerciante: descripción de la actividad",
    "a.consent": "Yo, como firmante, otorgo mi consentimiento para que cuando sea necesario y requerido, las partes de la relación contractual, puedan acceder, usar, compartir, tratar y/o custodiar mis datos personales y sensibles, incluyendo imágenes de mis documentos de identidad personal, para los propósitos relacionados a temas de las actividades comerciales y servicios financieros, por lo cual, acepto y reconozco que todos mis datos personales están amparados por los derechos ARCO (Acceso, Rectificación, Cancelación, Oposición y/o Portabilidad) en cumplimiento con la Ley de Seguros vigente junto a la Ley de Protección de Datos Personales y con su Reglamento vigente en la República de Panamá.",
    "a.sig_client": "Datos del Cliente", "a.sig_broker": "Datos del Corredor",
    "a.sig_insurer": "Solo para uso de la Aseguradora",
    "a.sig_name": "Nombre", "a.sig_reviewer": "Nombre del colaborador que revisa",
    "a.docs": "Copia de cédula o pasaporte (legible y vigente), y cualquier otro documento que la Compañía solicite.",
    "nav.pj_aseguradora": "DD PJ Aseguradora",
    "aj.title": "DD Persona Jurídica — Aseguradora",
    "aj.subtitle": "Formulario de cumplimiento BC/FT/FPADM según Acuerdo No. 3 del 22 de noviembre de 2022. Documento genérico, reutilizable por cualquier aseguradora.",
    "aj.sec1": "Datos generales de la sociedad", "aj.sec2": "Directores y dignatarios",
    "aj.sec3": "Accionistas / Beneficiarios finales", "aj.sec4": "Representante legal / Apoderado / Administrador",
    "aj.sec5": "Agente residente",
    "aj.legal_name": "Razón social", "aj.trade_name": "Razón comercial",
    "aj.ruc": "Registro Único de Contribuyente (RUC)", "aj.addr_phys": "Dirección física",
    "aj.const_country": "País de constitución", "aj.const_date": "Fecha de constitución",
    "aj.operating_countries": "País donde opera", "aj.activity": "Actividad a la que se dedica",
    "aj.phone": "Teléfono", "aj.website": "Sitio web",
    "aj.col_name": "Nombre completo", "aj.col_id": "Nº de identificación", "aj.col_birth": "F. de nacimiento",
    "aj.col_address": "Dirección", "aj.col_position": "Cargo", "aj.col_nat": "Nacionalidad",
    "aj.col_pct": "% de participación",
    "aj.sh_note": "Indique los principales socios con 10% o más de participación.",
    "aj.pep_intro": "¿Alguno de los miembros de esta sociedad (directores, dignatarios, representante legal, apoderado, socios, accionistas o beneficiarios finales) se encuentra dentro de la siguiente clasificación?",
    "aj.r1": "Menos de 50 mil", "aj.r2": "50 mil a 250 mil", "aj.r3": "250 mil a 500 mil",
    "aj.r4": "500 mil a 3 mio", "aj.r5": "3 mio a 5 mio", "aj.r6": "5 mio a 10 mio", "aj.r7": "Más de 10 mio",
    "aj.doc1": "Copia de cédula o pasaporte del Representante Legal o Apoderado (legible y vigente).",
    "aj.doc2": "Copia del Certificado del Registro Público.",
    "aj.doc3": "Aviso de Operación (si aplica).",
    "aj.doc4": "Cualquier otro documento que la Compañía de Seguros solicite.",
    "aj.footer": "Regulado y Supervisado por la Superintendencia de Seguros y Reaseguros de Panamá",
    "pf.view_edit": "Ver / Editar",
    "pf.modules": "Módulos habilitados para esta organización",
    "pf.all_modules": "Todos los módulos (sin restricción)",
    "pf.save_changes": "Guardar cambios",
    "pf.detail_title": "Detalle de la organización",
    "pp.readonly_note": "Lista nacional PEP de Panamá (solo lectura). Administrada por el super administrador.",
    "footer.last_login": "Último acceso",
    "ah.button": "Historial de accesos", "ah.title": "Historial de Accesos",
    "ah.date": "Fecha y hora", "ah.device": "Dispositivo / Navegador",
    "ah.user": "Usuario", "ah.tenant": "Organización",
    "ah.empty": "Sin accesos registrados", "ah.all_title": "Historial de accesos de todos los usuarios",
    "ah.period": "Vista", "ah.mode_all": "Todo", "ah.mode_account": "Por cuenta", "ah.mode_day": "Por día",
    "ah.mode_week": "Por semana", "ah.mode_month": "Por mes", "ah.week_start": "Semana que inicia",
    "ah.month": "Mes", "ah.from": "Desde", "ah.to": "Hasta", "ah.export_pdf": "PDF",
    "ah.export_all": "Exportar todo a PDF", "ah.accesses": "accesos",
    "nav.carta": "Carta de Responsabilidad",
    "nav.history": "Historial y reportes",
    "nav.users": "Usuarios y roles",
    "nav.logout": "Cerrar sesión",
    "sec.title": "Seguridad", "sec.devices": "Dispositivos confiables", "sec.devices_help": "Equipos donde no se solicita el código de verificación durante 30 días.",
    "sec.device": "Navegador / SO", "sec.added": "Alta", "sec.last_used": "Último uso", "sec.expires": "Vence", "sec.revoke": "Revocar", "sec.revoke_all": "Revocar todos",
    "sec.none": "No hay dispositivos confiables activos.", "sec.revoked": "Dispositivo revocado", "sec.revoked_all": "Todos los dispositivos fueron revocados", "sec.this_device": "Este equipo",
    "pw.change": "Cambiar contraseña",
    "pw.current": "Contraseña actual",
    "pw.new": "Nueva contraseña",
    "pw.confirm": "Confirmar nueva contraseña",
    "pw.mismatch": "Las contraseñas nuevas no coinciden",
    "pw.success": "Contraseña actualizada correctamente",
    "nav.section.main": "Principal",
    "nav.section.screening": "Verificación",
    "nav.section.forms": "Debida diligencia",
    "nav.section.admin": "Administración",
    "osint.title": "Búsqueda OSINT (fuentes abiertas)", "osint.subtitle_for": "Enlaces directos de búsqueda para:",
    "osint.subtitle_empty": "Escriba un nombre en el campo de búsqueda principal para generar los enlaces automáticamente.",
    "osint.pdf": "Generar PDF",
    "osint.reviewed": "Marcar como revisado", "osint.reviewed_count": "revisadas", "osint.finding_ph": "Hallazgo en esta fuente (opcional)",
    "osint.notes": "Notas de evidencia OSINT", "osint.notes_ph": "Resumen de hallazgos, coincidencias descartadas, capturas obtenidas…",
    "osint.save": "Guardar evidencia", "osint.saved": "Evidencia OSINT guardada en la consulta", "osint.attach": "Adjuntar a expediente",
    "osint.attached": "Reporte PDF adjuntado al expediente", "osint.pick_exp": "Seleccione expediente…",
    "nav.cyber": "Cyber Agency", "cy.title": "Cyber Agency", "nav.ntas": "Alertas NTAS",
    "nt.title": "Alertas de Terrorismo NTAS", "nt.subtitle": "National Terrorism Advisory System (DHS, EE.UU.) — alertas vigentes e historial; notificación automática al superadmin ante nuevas alertas",
    "nt.refresh": "Sincronizar ahora", "nt.active": "Vigentes", "nt.expired": "Historial (expiradas)", "nt.history": "Alertas registradas", "nt.last_sync": "Última sincronización",
    "nt.none_active": "Sin alertas vigentes", "nt.none_active_long": "DHS no tiene alertas ni boletines NTAS vigentes en este momento.", "nt.empty": "Sin alertas registradas",
    "nt.pdf_active": "PDF alertas activas", "nt.issued": "Emisión", "nt.expires": "Expira",
    "cy.suppliers_title": "Proveedores (KYP) con software expuesto", "cy.suppliers_none": "Ningún proveedor registrado coincide con vendors/productos del catálogo KEV.", "cy.suppliers_checked": "proveedores revisados",
    "cy.ntas_card": "Alertas de Terrorismo NTAS (DHS)", "cy.ntas_open": "Abrir módulo", "k.osint_summary": "Evidencia OSINT adjunta",
    "th.title": "Panel de amenazas", "th.since": "Última semana desde", "th.ntas": "Alertas NTAS vigentes (DHS)", "th.kev": "Vulnerabilidades nuevas (CISA KEV)", "th.total_week": "Total semana", "th.suppliers": "Proveedores expuestos", "k.intel_summary": "Reportes de inteligencia adjuntos (OSINT / CISA KEV / NTAS)",
    "cy.subtitle": "Catálogo de vulnerabilidades explotadas conocidas (CISA KEV) — consulta, filtrado y reporte para expedientes de debida diligencia",
    "cy.refresh": "Actualizar catálogo", "cy.catalog_total": "Total catálogo", "cy.critical": "Crítica", "cy.high": "Alta", "cy.released": "Publicación CISA", "cy.results": "Resultados",
    "cy.search": "Software / Vendor / CVE", "cy.search_ph": "Ej. Microsoft, Cisco, Chrome, CVE-2026-…", "cy.severity": "Severidad", "cy.from": "Publicado desde", "cy.to": "Publicado hasta",
    "cy.selected": "seleccionados", "cy.pdf": "PDF seleccionados", "cy.cve": "CVE ID", "cy.software": "Software afectado", "cy.name": "Vulnerabilidad", "cy.description": "Descripción",
    "cy.exploit_date": "Explotación conocida", "cy.action": "Acción requerida", "cy.due": "Fecha límite", "cy.ransomware": "Uso en ransomware", "cy.empty": "Sin vulnerabilidades para los filtros indicados",
    "search.missing_date": "Fecha de desaparición", "search.state_country": "Estado/País", "search.age": "Edad", "search.gender": "Género",
    "nav.section.platform": "Plataforma", "sw.title": "Organización activa", "sw.none": "Plataforma (sin organización)",
    "sw.acting_as": "Ahora operas dentro de la organización seleccionada con permisos de administrador", "sw.platform_mode": "Modo plataforma",
    "auth.login_title": "Iniciar sesión",
    "auth.register_title": "Crear organización",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.name": "Tipo de negocio",
    "auth.company": "Nombre de la organización",
    "auth.login_btn": "Entrar",
    "auth.register_btn": "Crear cuenta",
    "auth.ruc": "RUC",
    "auth.phone": "Teléfono",
    "auth.contact_person": "Persona de contacto",
    "auth.logo": "Logo de la empresa",
    "auth.logo_hint": "PNG, JPG o PDF, máx. 1.3 MB. Se mostrará en el panel.",
    "auth.logo_error": "El logo debe ser PNG, JPG o PDF de máx. 1.3 MB",
    "auth.subtitle": "Plataforma KYC — Gestión de Debida Diligencia y verificación de identidad",
    "brand.ssnf": "Superintendencia de Sujetos No Financieros de Panamá",
    "auth.b1": "Listas OFAC y CSNU actualizadas cada 24 horas",
    "auth.b2": "Reportes PDF firmados digitalmente",
    "auth.b3": "Formularios oficiales de debida diligencia",
    "auth.version": "KYCFederal v6.1.8 2026",
    "auth.otp_title": "Verificación en dos pasos", "auth.forgot_link": "¿Olvidó su contraseña?", "auth.forgot_title": "Restablecer contraseña", "auth.forgot_help": "Ingrese su correo y le enviaremos un enlace válido por 1 hora.", "auth.forgot_btn": "Enviar enlace", "auth.forgot_sent": "Si el correo está registrado, recibirá un enlace para restablecer su contraseña. Revise también la carpeta de spam.", "auth.reset_title": "Crear nueva contraseña", "auth.reset_new": "Nueva contraseña (mín. 8 caracteres)", "auth.reset_confirm": "Confirmar nueva contraseña", "auth.reset_btn": "Guardar contraseña", "auth.reset_mismatch": "Las contraseñas no coinciden.", "auth.reset_done": "Su contraseña fue actualizada. Los dispositivos confiables fueron revocados por seguridad.",
    "rep.send": "Enviar reporte por correo", "rep.title": "Enviar reporte PDF por correo", "rep.help": "Se enviará el PDF completo de esta verificación como adjunto:", "rep.to": "Correo destino", "rep.confirm": "Confirmar envío", "rep.sent": "Reporte enviado a",
    "pu.actions": "Acciones", "pu.new_temp_password": "Nueva contraseña temporal", "pu.leave_blank": "Dejar en blanco para no cambiarla", "pu.create_sa": "Crear Super Admin", "pu.sa_created": "Super administrador creado. Se enviaron las credenciales por correo.", "pu.sa_help": "El nuevo super administrador tendrá acceso total a la plataforma y a todas las organizaciones. Recibirá un correo de bienvenida con sus credenciales de acceso.", "pu.title": "Gestión de usuarios", "pu.create": "Crear usuario", "pu.created": "Usuario creado. Se envió el correo de bienvenida.", "pu.temp_password": "Contraseña temporal", "pu.send_credentials": "Incluir las credenciales en el correo de bienvenida", "pu.search_ph": "Buscar por nombre, correo u organización…", "pu.activated": "Usuario activado", "pu.deactivated": "Usuario desactivado", "pu.edit_title": "Editar usuario", "pu.reset": "Enviar restablecimiento de contraseña", "pu.reset_sent": "Enlace de restablecimiento enviado a", "pu.delete_confirm": "¿Eliminar definitivamente al usuario? Esta acción no se puede deshacer.",
    "pf.contacts_title": "Bandeja de contactos", "pf.contacts_new": "nuevos", "pf.contacts_all": "Todos", "pf.contacts_only_new": "Solo nuevos", "pf.contacts_handled": "Atendido", "pf.contacts_mark_handled": "Marcar atendido", "pf.contacts_reopen": "Reabrir", "pf.contacts_none": "No hay mensajes.", "pf.contacts_note": "Nota interna (opcional)", "auth.otp_remember": "Confiar en este dispositivo por 30 días (no pedir código aquí)", "auth.otp_help": "Enviamos un código de 6 dígitos a", "auth.otp_verify": "Verificar y entrar", "auth.otp_resend": "Reenviar código", "auth.otp_back": "Volver", "auth.otp_expiry": "El código vence en 10 minutos. Máximo 5 intentos.", "auth.otp_resent": "Nuevo código enviado a su correo.",

    "auth.panama_time": "Hora de Panamá",
    "auth.compliance": "Cumplimiento normativo",
    "common.search": "Buscar",
    "common.loading": "Cargando…",
    "common.search": "Buscar",
    "common.save": "Guardar registro",
    "common.saving": "Guardando…",
    "common.cancel": "Cancelar",
    "common.yes": "Sí",
    "common.no": "No",
    "common.other": "Otro",
    "common.all": "Todos", "common.view": "Ver", "common.close": "Cerrar",
    "common.actions": "Acciones",
    "common.date": "Fecha",
    "common.user": "Usuario",
    "common.type": "Tipo",
    "common.result": "Resultado",
    "common.download_pdf": "Descargar PDF",
    "common.download_excel": "Exportar Excel",
    "common.delete": "Eliminar",
    "common.add_row": "Agregar fila",
    "common.export_pdf": "Exportar PDF",
    "common.optional": "opcional",
    "common.client_id": "ID de cliente",
    "common.edit": "Editar",
    "common.deactivate": "Desactivar",
    "common.activate": "Activar", "common.refresh": "Actualizar",
    "common.inactive": "Inactivo",
    "frl.title": "Registros creados",
    "frl.search_ph": "Buscar por nombre o número…",
    "frl.status": "Estado",
    "frl.st_active": "Activos",
    "frl.st_inactive": "Inactivos",
    "frl.st_all": "Todos",
    "frl.view": "Ver",
    "frl.detail": "Detalle del registro",
    "frl.from": "Desde",
    "frl.to": "Hasta",
    "frl.signature_done": "Firma registrada",
    "frl.new": "Nuevo registro",
    "vs.label": "Estatus de verificación",
    "vs.negativo": "Negativo",
    "vs.falso_positivo": "Falso Positivo",
    "vs.en_revision": "En Revisión",
    "vs.positivo_confirmado": "Positivo / Confirmado",
    "vs.d_negativo": "Sin coincidencias en la lista.",
    "vs.d_falso_positivo": "Coincidencia de nombre descartada con datos secundarios.",
    "vs.d_en_revision": "Coincidencia parcial; investigación o cotejo documental en proceso.",
    "vs.d_positivo_confirmado": "Coincidencia exacta confirmada con sujeto sancionado.",
    "vs.notes": "Información adicional",
    "vs.notes_ph": "Detalles o información relevante…",
    "vs.saved": "Estatus de verificación actualizado",
    "nav.tv": "Vista TV",
    "tv.title": "Monitor de verificación",
    "tv.exit": "Salir",
    "tv.live": "EN VIVO",
    "tv.dbs": "Bases de datos — estado de actualización",
    "tv.entries": "registros",
    "tv.updated": "Actualizada",
    "tv.total": "Consultas totales",
    "tv.positives": "Positivas",
    "tv.negatives": "Negativas",
    "tv.today": "Consultas de hoy",
    "tv.recent": "Actividad reciente",
    "tv.positive": "POSITIVO",
    "tv.negative": "NEGATIVO",
    "tv.internal_bl": "Lista negra interna",
    "tv.internal_note": "Registros activos",
    "common.show_inactive": "Mostrar inactivos",
    "forms.updated": "Formulario actualizado correctamente",
    "forms.attachments": "Documentos requeridos (máx. 3 archivos de 1.5 MB)",
    "forms.max_files": "Máximo 3 archivos",
    "forms.public_link": "Link público",
    "forms.link_title": "Enlace público de registro",
    "forms.link_help": "Comparta este enlace con su cliente o proveedor para que complete el formulario y suba sus documentos sin necesidad de usuario. Al finalizar, ambos recibirán notificación por email.",
    "forms.copy": "Copiar",
    "forms.link_copied": "Enlace copiado al portapapeles",
    "forms.send_link": "Enviar",
    "forms.link_sent": "Enlace enviado por email",
    "forms.revoke": "Revocar enlace",
    "forms.revoked": "Enlace revocado",
    "forms.uses": "registros recibidos",
    "forms.public_done": "¡Registro enviado correctamente!",
    "forms.public_done_no": "Su número de documento es:",
    "forms.invalid_link": "El enlace es inválido o fue revocado. Contacte a la organización.",
    "forms.qr_hint": "Escanee este código para abrir el formulario en el móvil. Ideal para recepción o documentos impresos.",
    "forms.qr_download": "Descargar QR",
    "vf.title": "Verificación de documentos",
    "vf.valid": "Documento auténtico",
    "vf.invalid": "Documento no encontrado o inválido",
    "vf.number": "Número de documento",
    "vf.type": "Tipo de documento",
    "vf.org": "Organización",
    "vf.date": "Fecha de emisión",
    "vf.seal": "Sello criptográfico (HMAC-SHA256)",
    "vf.hint": "Compare el número y el sello con el documento PDF presentado.",
    "vf.kind_search": "Consulta en listas de sanciones",
    "vf.kind_pep": "Consulta PEP/RCA",
    "vf.kind_form": "Formulario de debida diligencia",
    "vf.kind_ros": "Reporte de Operación Sospechosa (ROS)",
    "vf.kind_rte": "Reporte de Transacción en Efectivo (RTE)",
    "vf.kind_freeze": "Congelamiento preventivo CSNU",
    "dash.clients": "Clientes",
    "dash.view_record": "Ver expediente",
    "dash.title": "Panel principal",
    "dash.welcome": "Resumen de actividad de su organización",
    "dash.total_searches": "Consultas realizadas",
    "dash.matches": "Coincidencias",
    "dash.cleared": "Sin coincidencia",
    "dash.total_forms": "Formularios registrados",
    "dash.users": "Usuarios del tenant",
    "dash.month_by_source": "Consultas del mes por fuente", "dash.month_since": "Desde el", "tv.ntas_active": "vigentes", "tv.ntas_hist": "en historial",
    "pf.plan_all": "Todo el plan", "pf.plan_sources": "+ Todas las fuentes", "pf.plan_no_sources": "− Quitar fuentes", "pf.plan_basic": "Solo básico",
    "dash.recent_searches": "Consultas recientes",
    "dash.recent_forms": "Formularios recientes",
    "dash.lists": "Estado de las listas de sanciones",
    "dash.no_data": "Sin registros aún",
    "dash.view_detail": "Ver detalle",
    "nav.fbi": "FBI Most Wanted", "nav.interpol": "INTERPOL", "nav.wb": "Banco Mundial", "nav.osint": "Búsqueda OSINT", "nav.namus": "NamUs 2.0", "nav.icmp": "ICMP Desaparecidos",
    "mod.fbi": "FBI Most Wanted", "mod.fbi_sub": "Búsqueda en la lista de personas más buscadas del FBI (EE.UU.).",
    "mod.interpol": "INTERPOL — Notificaciones rojas", "mod.interpol_sub": "Consulta en vivo de notificaciones rojas de INTERPOL.",
    "mod.wb": "Banco Mundial — Inhabilitados", "mod.wb_sub": "Empresas e individuos inhabilitados por el Grupo Banco Mundial.",
    "mod.namus": "NamUs 2.0 — Personas desaparecidas", "mod.namus_sub": "Consulta en vivo del National Missing and Unidentified Persons System (EE.UU.).",
    "osint.open_for": "Abrir evidencia OSINT para", "osint.module_title": "Búsqueda OSINT", "osint.module_subtitle": "Enlaces directos a fuentes abiertas (Google, LinkedIn, X, Facebook, Pipl, TruePeopleSearch, Interpol, ICMP, MP Panamá, NamUs) con evidencia guardable en la consulta.",
    "osint.module_hint": "Para guardar evidencia y adjuntarla a un expediente, ejecute primero la búsqueda en Listas de sanciones y use la sección OSINT del resultado.",
    "icmp.title": "ICMP — Personas desaparecidas", "icmp.subtitle": "International Commission on Missing Persons — Online Inquiry Center. Búsqueda por país, género y edad.",
    "icmp.note": "ICMP no permite búsqueda por nombre: su base contiene personas desaparecidas y restos no identificados, consultables por país, género, grupo de edad y fecha. Los enlaces abren el buscador oficial con los filtros pre-cargados.",
    "icmp.link_pa": "Buscar desaparecidos — Panamá (con filtros)", "icmp.link_all": "Buscador ICMP — todos los países", "icmp.link_report": "Reportar una persona desaparecida",
    "st.modules": "Módulos habilitados", "st.modules_help": "Active o desactive módulos para toda la organización. Los módulos desactivados desaparecen del menú y sus consultas quedan bloqueadas para todos los usuarios.", "st.module_plan": "no incluido en el plan",
    "search.title": "OFAC-ONU-GAFI",
    "search.subtitle": "Verificación individual y masiva en las listas oficiales OFAC (SDN), CSNU (ONU) y GAFI (FATF).",
    "search.individual": "Búsqueda individual",
    "search.bulk": "Búsqueda masiva",
    "search.name_label": "Nombre de la persona o entidad",
    "search.name_ph": "Ej.: Juan Pérez / Empresa S.A.",
    "search.type_label": "Tipo",
    "search.t_all": "All",
    "search.t_aircraft": "Aircraft",
    "search.t_entity": "Entity",
    "search.t_individual": "Individual",
    "search.t_vessel": "Vessel",
    "search.sources": "Fuentes",
    "search.run": "Consultar listas",
    "search.running": "Consultando…",
    "search.match": "COINCIDENCIA ENCONTRADA",
    "search.no_match": "SIN COINCIDENCIA",
    "search.matches_found": "coincidencias potenciales",
    "search.consult_no": "Consulta No.",
    "search.col_list": "Lista",
    "search.col_name": "Nombre en lista",
    "search.col_type": "Tipo",
    "search.col_program": "Programa / Régimen",
    "search.col_ref": "Referencia",
    "search.col_score": "Score",
    "search.alias": "Alias coincidente",
    "search.nationality": "Nacionalidad",
    "search.dob": "F. nacimiento",
    "search.country": "País",
    "search.grounds": "Motivo",
    "search.period": "Vigencia",
    "search.ongoing": "Vigente",
    "search.official_link": "Ficha oficial",
    "search.bulk_help": "Ingrese un nombre por línea (máx. 500). Cada nombre genera su propio reporte PDF con número de consulta único.",
    "search.bulk_run": "Consultar todos",
    "search.col_query": "Nombre consultado",
    "search.col_matches": "Coincidencias",
    "search.last_update": "Última actualización",
    "search.entries": "registros",
    "search.refresh": "Actualizar ahora",
    "search.refresh_started": "Actualización iniciada en segundo plano",
    "search.status_ok": "Actualizada",
    "search.status_error": "Error",
    "search.status_pending": "Pendiente",
    "search.auto_note": "Las listas se descargan automáticamente desde las fuentes oficiales y se actualizan cada 24 horas.",
    "search.et_individual": "Individual", "search.et_person": "Individual",
    "search.et_entity": "Entidad", "search.et_vessel": "Embarcación",
    "search.et_aircraft": "Aeronave", "search.et_jurisdiction": "Jurisdicción",
    "search.person": "Persona",
    "search.new": "Nueva búsqueda",
    "search.pdf": "PDF", "search.excel": "Excel",
    "search.send_email": "Enviar por email",
    "search.email_sent": "Reporte enviado por correo a",
    "search.entity": "Entidad",
    "search.results": "Resultados",
    "p.title": "Búsqueda PEP / RCA — OpenSanctions",
    "p.subtitle": "Personas Expuestas Políticamente (PEP) y Personas de Riesgo y Corrupción (RCA) — base de datos abierta de OpenSanctions, sincronizada automáticamente cada 24 horas",
    "p.query_label": "Nombre, documento de identidad o entidad",
    "p.query_ph": "Ej.: Vladimir Putin / 8-888-888 / Empresa S.A.",
    "p.id_note": "Puede buscar por nombre completo, alias, número de documento de identidad o nombre de entidad.",
    "p.category": "Categoría",
    "p.cat_all": "PEP y RCA",
    "p.found": "PEP/RCA ENCONTRADO",
    "p.col_category": "Categoría",
    "p.col_position": "Cargo / fuente del cargo",
    "p.col_country": "País",
    "p.col_since": "Inclusión",
    "p.attribution": "Datos de OpenSanctions (opensanctions.org) — CC BY-NC 4.0",
    "forms.save_success": "Formulario registrado correctamente",
    "forms.doc_no": "Documento No.",
    "forms.signature": "Firma",
    "forms.sign_hint": "Firme dentro del recuadro con el mouse o el dedo",
    "forms.clear": "Limpiar firma",
    "forms.sign_required": "Debe firmar el formulario antes de guardar",
    "n.title": "Debida Diligencia — Persona Natural",
    "n.subtitle": "Formulario de registro de cliente nuevo o actualización de datos",
    "n.sec1": "I. Datos personales",
    "n.sec2": "II. Perfil financiero",
    "n.sec3": "III. Información PEP",
    "n.sec4": "IV. Referencias bancarias",
    "n.sec5": "V. Referencias comerciales",
    "n.sec6": "VI. Preguntas adicionales",
    "n.sec7": "VII. Firma del cliente",
    "n.record_type": "Tipo de registro",
    "n.rt_new": "Cliente nuevo",
    "n.rt_update": "Actualización de datos",
    "n.first_name": "Primer nombre",
    "n.second_name": "Segundo nombre",
    "n.last_name_p": "Apellido paterno",
    "n.last_name_m": "Apellido materno",
    "n.last_name_c": "Apellido de casada",
    "n.id_number": "Cédula o pasaporte",
    "n.birth_date": "Fecha de nacimiento",
    "n.gender": "Género",
    "n.gender_m": "Masculino",
    "n.gender_f": "Femenino",
    "n.gender_o": "Otro",
    "n.nationality": "Nacionalidad",
    "n.residence_country": "País de residencia",
    "n.marital_status": "Estado civil",
    "n.ms_single": "Soltero(a)",
    "n.ms_married": "Casado(a)",
    "n.ms_divorced": "Divorciado(a)",
    "n.ms_widowed": "Viudo(a)",
    "n.birth_country": "País de nacimiento",
    "n.home_phone": "Teléfono residencial",
    "n.mobile": "Número celular",
    "n.email": "Correo electrónico",
    "n.po_box": "Apartado postal",
    "n.address": "Dirección residencial",
    "n.employer": "Empresa donde trabaja",
    "n.profession": "Profesión",
    "n.work_phone": "Teléfono de trabajo",
    "n.position": "Cargo",
    "n.income_main": "Ingresos anuales — actividad principal",
    "n.income_other": "Ingresos anuales — otras actividades",
    "n.r1": "Menos de $75,000",
    "n.r2": "$75,000 a $100,000",
    "n.r3": "$100,001 a $150,000",
    "n.r4": "Más de $150,000",
    "n.payment_methods": "Formas de pago preferidas",
    "n.pm_check": "Cheque",
    "n.pm_cc": "Tarjeta de crédito",
    "n.pm_wire": "Transferencia bancaria internacional",
    "n.pm_ach": "Transferencia ACH",
    "n.pm_cash": "Efectivo",
    "n.pm_other": "Otro",
    "n.payment_other": "Especifique otra forma de pago",
    "n.funds_origin": "Descripción de la procedencia de los fondos",
    "n.is_pep": "¿Es persona políticamente expuesta (PEP)?",
    "n.pep_position": "Cargo actual",
    "n.pep_date": "Fecha del cargo",
    "n.is_pep_relative": "¿Es familiar cercano de un PEP?",
    "n.pep_relative_name": "Nombre completo del familiar PEP",
    "n.bank": "Banco",
    "n.contact": "Persona de contacto",
    "n.phone": "Teléfono",
    "n.legal_name_ref": "Nombre o razón social",
    "n.dd_process": "¿Realiza debida diligencia a clientes y proveedores?",
    "n.dd_process_desc": "Descripción del proceso",
    "n.investigated": "¿Algún empleado, propietario o ejecutivo ha sido investigado por blanqueo de capitales, corrupción o investigación criminal?",
    "n.investigated_desc": "Explicación",
    "n.client_name": "Nombre del cliente",
    "j.title": "Debida Diligencia — Persona Jurídica",
    "j.doc_aviso": "Aviso de Operaciones", "j.doc_registro_publico": "Registro Público",
    "j.doc_cedula": "Cédula o Pasaporte", "j.doc_ref_bancaria": "Carta de Referencia Bancaria",
    "j.subtitle": "Formulario de debida diligencia para empresas y entidades legales",
    "j.sec1": "I. Datos de la empresa",
    "j.sec2": "II. Directores y dignatarios",
    "j.sec3": "III. Representante legal",
    "j.sec4": "IV. Beneficiario final principal",
    "j.sec5": "V. Información PEP del representante",
    "j.sec6": "VI. Condiciones de cuenta y métodos de pago",
    "j.sec7": "VII. Referencias bancarias",
    "j.sec8": "VIII. Referencias comerciales",
    "j.sec9": "IX. Clientes principales",
    "j.sec10": "X. Proveedores principales",
    "j.sec11": "XI. Preguntas adicionales",
    "j.sec12": "XII. Declaración y firma",
    "j.legal_name": "Nombre legal",
    "j.trade_name": "Nombre comercial",
    "j.tax_id": "Número de identificación (RUC/NIT)",
    "j.incorporation_country": "País de incorporación",
    "j.economic_sector": "Sector económico",
    "j.products_services": "Productos y servicios que ofrece",
    "j.address": "Dirección física",
    "j.phone": "Teléfono",
    "j.fax": "Fax",
    "j.website": "Sitio web",
    "j.email": "Correo electrónico",
    "j.registration_date": "Fecha de registro",
    "j.branches": "Número de sucursales",
    "j.employees": "Número de empleados",
    "j.full_name": "Nombre completo",
    "j.id_number": "Cédula o pasaporte",
    "j.board_position": "Cargo en Junta Directiva",
    "j.is_pep": "¿Es PEP?",
    "j.current_position": "Cargo actual",
    "j.current_since": "Desde (fecha)",
    "j.previous_position": "Cargo anterior",
    "j.previous_until": "Hasta (fecha)",
    "j.rep_position": "Cargo",
    "j.rep_address": "Dirección",
    "j.rep_nationality": "Nacionalidad",
    "j.rep_profession": "Profesión",
    "j.ubo_name": "Nombre y apellido",
    "j.ubo_phone": "Teléfono",
    "j.ubo_email": "Correo electrónico",
    "j.ubo_pct": "Porcentaje de propiedad (%)",
    "j.rep_is_pep": "¿Es PEP?",
    "j.rep_pep_position": "Cargo actual",
    "j.rep_pep_date": "Fecha",
    "j.rep_is_relative": "¿Familiar cercano de PEP?",
    "j.rep_relative_name": "Nombre del familiar",
    "j.payment_methods": "Métodos de pago",
    "j.pm_credit_debit": "Crédito / débito",
    "j.pm_wire": "Transferencia bancaria",
    "j.funds_origin": "Descripción de la procedencia de fondos",
    "j.business_desc": "Descripción del negocio",
    "j.position_col": "Cargo",
    "j.political": "¿La empresa está vinculada a algún partido político?",
    "j.political_desc": "Detalle",
    "j.shareholders_other": "¿Los accionistas aparecen como dueños de otros negocios?",
    "j.shareholders_other_desc": "Detalle",
    "j.decl_text": "Declaro que la información proporcionada es veraz y completa, y autorizo su verificación.",
    "j.rep_name_sign": "Nombre del representante legal o apoderado",
    "j.signer_position": "Cargo",
    "d.title": "Declaración de Origen de Fondos",
    "d.subtitle": "Declaración juramentada de procedencia lícita de fondos",
    "d.declarant_name": "Nombre del declarante",
    "d.id_number": "Documento de identidad",
    "d.tax_id": "NIT / RUC",
    "d.legal_representation": "Representación legal (si aplica)",
    "d.funds_origin": "Descripción del origen de los fondos",
    "d.lawful": "Declaración de actividad lícita",
    "d.lawful_default": "Declaro bajo juramento que los fondos descritos provienen de actividades lícitas y no están relacionados con blanqueo de capitales, financiamiento del terrorismo ni ninguna otra actividad ilícita.",
    "d.client_name": "Nombre del cliente",
    "cr.title": "Carta de Liberación de Responsabilidad",
    "cr.subtitle": "Carta de responsabilidad con línea de crédito",
    "cr.name": "Nombre del declarante",
    "cr.cip": "C.I.P. (cédula de identidad personal)",
    "cr.nationality": "Nacionalidad",
    "cr.trade_name": "Nombre comercial o Razón Social",
    "cr.address": "Dirección",
    "cr.printed_name": "Nombre (a pie de firma)",
    "cr.nip": "N.I.P. (número de identificación personal)",
    "cr.preview_note": "El PDF se genera con el formato oficial de la carta (título, destinatario, cuerpo, firma y pie legal).",
    "cr.recipient_sec": "Empresa Receptora",
    "cr.recipient_name": "Nombre de la empresa",
    "cr.recipient_dv": "DV (dígito verificador)",
    "cr.recipient_ruc": "ConR.U.C.",
    "c.title": "Beneficiario Final",
    "c.subtitle": "Registro oficial de beneficiarios finales (UBO)",
    "c.date": "Fecha",
    "c.signer_name": "Nombre del suscrito",
    "c.signer_id": "ID / Pasaporte",
    "c.capacity": "Capacidad",
    "c.cap_president": "Presidente",
    "c.cap_secretary": "Secretario",
    "c.cap_legal_rep": "Representante Legal",
    "c.cap_attorney": "Apoderado",
    "c.company_name": "Nombre de la sociedad",
    "c.ubos": "Beneficiarios finales",
    "c.col_name": "Nombre",
    "c.col_id": "ID / Pasaporte / RUC",
    "c.col_nat": "Nacionalidad",
    "c.col_role": "Cargo o rol en la empresa",
    "c.col_birth_addr": "Fecha de nacimiento o dirección física",
    "c.col_pct": "% Propiedad",
    "c.col_public": "Figura pública / cargo / periodo (o N/A)",
    "c.pct_total": "Total de participación",
    "c.pct_warn": "La suma de porcentajes no alcanza el 100%",
    "c.rep_name": "Nombre del representante",
    "c.rep_position": "Cargo del representante",
    "h.title": "Historial y reportes",
    "h.subtitle": "Historial de consultas y formularios de su organización (últimos 7 días)",
    "h.clear_sel": "Limpiar selección",
    "h.q_ph": "Buscar por nombre…",
    "h.kind": "Módulo",
    "h.k_all": "Todo",
    "h.k_searches": "Consultas en listas",
    "h.k_forms": "Formularios",
    "h.r_all": "Todos los resultados",
    "h.r_match": "Con coincidencia",
    "h.r_no": "Sin coincidencia",
    "h.form_type": "Tipo de formulario",
    "h.from": "Desde",
    "h.to": "Hasta",
    "h.number": "Número",
    "h.name_title": "Nombre / Título",
    "h.module": "Módulo",
    "h.search": "Consulta en listas",
    "h.pep": "Consulta PEP/RCA",
    "h.k_pep": "Consultas PEP/RCA",
    "h.empty": "No se encontraron registros con los filtros aplicados",
    "u.title": "Usuarios y roles",
    "u.subtitle": "Gestión de usuarios de su organización",
    "u.add": "Nuevo usuario",
    "u.name": "Nombre",
    "u.email": "Correo",
    "u.role": "Rol",
    "u.admin": "Administrador",
    "u.operator": "Operador",
    "u.status": "Estado",
    "u.active": "Activo",
    "u.inactive": "Inactivo",
    "u.create_title": "Crear usuario",
    "u.create": "Crear",
    "u.only_admin": "Solo los administradores pueden gestionar usuarios.",
    "u.deactivate": "Desactivar", "u.delete": "Eliminar", "u.deleted": "Usuario eliminado definitivamente",
    "u.cleanup": "Limpiar usuarios TEST_", "u.cleanup_confirm": "¿Eliminar definitivamente los {n} usuarios de prueba (nombre TEST_ o correo test_) de esta organización?",
    "u.cleanup_done": "{n} usuarios de prueba eliminados", "u.cleanup_none": "No hay usuarios de prueba en esta organización",
    "u.delete_confirm": "¿Eliminar definitivamente al usuario {email}? Esta acción no se puede deshacer.",
    "sw.banner": "Operando como Super Administrador dentro de la organización:",
    "sw.hint": "Para ver el menú completo (módulos, usuarios y roles, configuración) seleccione una organización en el selector \"Organización activa\" de la barra superior.",
    "u.activate": "Activar",
    "u.created": "Usuario creado correctamente",
    "u.updated": "Usuario actualizado",
    "u.new_password": "Nueva contraseña (dejar vacío para no cambiar)",
    "u.type": "Tipo",
    "u.platform_admin": "Adm. plataforma",
    "u.tenant_client": "Cliente tenant",
    "u.notify_email": "Email de notificación",
    "u.notify_hint": "Recibe copia de las alertas del tenant",
    "u.duration": "Duración de uso",
    "u.months": "Meses",
    "u.days": "Días",
    "u.hours": "Horas",
    "u.expires": "Vence",
    "u.expired": "Expirado",
    "u.no_limit": "Sin límite",
    "u.edit": "Editar",
    "u.cancel": "Cancelar",
    "u.modules": "Módulos habilitados",
    "u.save": "Guardar cambios",
    "u.duration_hint": "Vacío = sin límite. Al editar, renueva desde hoy; 0/0/0 quita el límite.",
    "u.client": "Cliente",
    "u.provider": "Proveedor",
    "u.auditor": "Auditor",
    "u.superadmin": "Super Admin",
    "nav.platform": "Plataforma global",
    "pf.purge_btn": "Limpiar org. de prueba", "pf.purge_title": "Eliminar organizaciones de prueba", "pf.purge_help": "Se detectaron automáticamente organizaciones de prueba (TEST_, DemoCorp, Prueba, resend.dev). Se enviarán a la papelera con sus usuarios desactivados; podrá restaurarlas durante 30 días antes del borrado definitivo.", "pf.purge_none": "No hay organizaciones de prueba.", "pf.users_short": "usuarios", "pf.purge_confirm": "Enviar a papelera", "pf.purge_ask": "¿Enviar {n} organización(es) de prueba a la papelera? Sus usuarios quedarán desactivados.", "pf.purge_done": "{n} organización(es) enviadas a la papelera (30 días)",
    "pf.trash_btn": "Papelera", "pf.trash_title": "Papelera de organizaciones", "pf.trash_help": "Las organizaciones eliminadas permanecen aquí 30 días con todos sus datos y usuarios (desactivados). Al cumplirse el plazo se notifica al superadministrador; los datos se conservan hasta que confirme la eliminación definitiva con «Eliminar ahora».", "pf.trash_none": "La papelera está vacía.", "pf.trash_since": "en papelera desde", "pf.trash_days_left": "días restantes", "pf.trash_restore": "Restaurar", "pf.trash_delete_now": "Eliminar ahora", "pf.trash_restored": "Organización {name} restaurada", "pf.trash_deleted": "Organización {name} eliminada definitivamente", "pf.trash_delete_ask": "¿Eliminar definitivamente {name} y todos sus datos? Esta acción no se puede deshacer.",
    "ah.query": "Consultar", "ah.type": "Tipo", "ah.type_login": "Inicio de sesión", "ah.type_action": "Acción", "ah.filter_user": "Filtrar por usuario o correo…", "ah.filter_org": "Filtrar por organización…", "ah.records": "registros", "ah.not_queried": "Defina el período y pulse Consultar para ver el historial de accesos y acciones.",
    "nav.vessels": "OFAC Vessel", "vs.title": "OFAC Vessel — Embarcaciones sancionadas", "vs.subtitle": "Base consolidada de buques sancionados por OFAC y otras autoridades (FCDO, UANI, EU, ASO, MFAT, GAC, SECO, UN). Busque por nombre, bandera, tipo de nave o número IMO.",
    "vs.import_title": "Actualizar lista desde Excel", "vs.import_help": "Formato: hoja 'Base de Datos' con columnas Buque, IMO, Año de construcción, Clase (tamaño), Bandera y una columna de fecha por lista (OFAC, FCDO, UANI, EU, ASO, MFAT, GAC, SECO, UN). El archivo reemplaza la lista completa.",
    "vs.import_btn": "Importar Excel", "vs.import_confirm": "La lista actual será reemplazada por completo por el contenido del archivo. ¿Continuar?", "vs.imported": "embarcaciones importadas", "vs.import_warn": "fila(s) con advertencias (IMO inválido)",
    "vs.last_import": "Última actualización", "vs.records": "registros", "vs.total": "Buques en la base", "vs.flags": "Banderas", "vs.types": "Tipos de nave",
    "vs.name": "Nombre del buque", "vs.name_ph": "Ej. ABRAU, ACE…", "vs.flag": "Bandera", "vs.type": "Tipo de nave", "vs.any_list": "Cualquier lista", "vs.sanction_date": "Fecha de sanción", "vs.program": "Programa OFAC / Listas", "vs.built": "Construido", "vs.last_date": "Última",
    "vs.results": "embarcaciones encontradas", "vs.showing": "mostrando", "vs.none": "Sin resultados para los criterios indicados.", "common.clear": "Limpiar", "vs.first_date": "Primera designación", "vs.last_date_full": "Última designación", "vs.by_authority": "Designación por autoridad", "vs.not_listed": "No figura", "vs.click_hint": "Haga clic en un registro para ver la ficha completa y exportarla.",
    "pf.lookup_title": "Rastrear organización o usuario", "st.module_always": "siempre activo", "pf.sync_title": "Sincronización de fuentes (cada 24 h automática)", "pf.sync_refresh": "Actualizar estado", "pf.sync_now": "Sincronizar ahora:", "pf.sync_records": "registros", "pf.sync_started": "Sincronización iniciada en segundo plano; el estado se actualizará en unos minutos.", "pf.lookup_help": "Busca en todas las organizaciones (incluidas pendientes, rechazadas, archivadas y en papelera), usuarios y el registro de auditoría de la plataforma.", "pf.lookup_ph": "Nombre de organización, correo o usuario…", "pf.lookup_none": "Sin resultados para ese criterio.", "pf.lookup_tenants": "Organizaciones", "pf.lookup_users": "Usuarios", "pf.lookup_events": "Auditoría", "pf.lookup_in_selector": "Visible en selector de Organización activa", "pf.lookup_not_selector": "No visible en el selector (estado)", "pf.lookup_in_trash": "En papelera",

    "pf.title": "Plataforma global",
    "pf.subtitle": "Administración de organizaciones (tenants) y métricas globales de uso.",
    "pf.new_tenant": "Nueva organización",
    "pf.tenants": "Organizaciones",
    "pf.users": "Usuarios",
    "pf.forms": "Formularios",
    "pf.searches": "Consultas",
    "pf.created": "Creada",
    "pf.tenant_created": "Organización creada correctamente",
    "pf.stats_tenants": "Organizaciones activas",
    "pf.stats_users": "Usuarios totales",
    "pf.stats_searches": "Consultas realizadas",
    "pf.stats_forms": "Formularios registrados",
    "pf.stats_expedientes": "Expedientes",
    "pf.stats_alerts": "Alertas registradas",
    "pf.usage_title": "Uso mensual por organización (consultas + formularios)",
    "pf.pending": "Solicitudes de registro pendientes", "pf.pending_help": "Organizaciones registradas desde el portal que esperan aprobación. Al aprobar se activa la cuenta y se envía un correo de bienvenida al administrador; al rechazar se notifica por correo con el motivo indicado.", "pf.requested_at": "Solicitud:", "pf.reject_optional": "Opcional. Ej.: RUC inválido, información incompleta…",
    "pf.approve": "Aprobar",
    "pf.reject": "Rechazar",
    "pf.reject_reason": "Motivo del rechazo (se enviará por correo al solicitante)",
    "pf.reject_confirm": "Confirmar rechazo",
    "pf.pending_status": "Pendiente",
    "pf.rejected": "Rechazada",
    "pf.approved_msg": "Organización aprobada y notificada por correo",
    "pf.rejected_msg": "Solicitud rechazada y notificada por correo",
    "auth.pending_title": "Solicitud enviada",
    "auth.pending_countdown": "Será redirigido al inicio en {s} segundos", "auth.back_home": "Volver al inicio",
    "auth.pending_msg": "Su organización quedó registrada y está pendiente de aprobación por el administrador de la plataforma. Recibirá un correo de confirmación con el enlace de acceso.",
    "st.notify_matrix": "Notificaciones por tipo de alerta",
    "st.notify_matrix_help": "Active o desactive cada tipo de notificación y defina el correo destinatario (vacío = correo de alertas general).",
    "st.nt_list_match": "Coincidencias en listas restrictivas (OFAC, CSNU, GAFI, FBI, OpenSanctions)",
    "st.nt_blacklist_match": "Coincidencias en Lista Negra interna",
    "st.nt_high_risk": "Clientes con nivel de riesgo alto",
    "st.nt_ros": "Operaciones inusuales (ROS)",
    "st.nt_freeze": "Congelamientos preventivos CSNU",
    "st.nt_expiry": "Vencimientos de debida diligencia",
    "st.nt_portal_doc": "Documentos subidos desde el portal del cliente",
    "st.nt_email": "Correo destinatario (opcional)",
    "u.linked_record": "Expediente vinculado",
    "u.no_link": "— Sin vincular —",
    "nav.portal": "Mi portal",
    "portal.title": "Mi portal",
    "portal.subtitle": "Estado de su expediente de debida diligencia y documentos disponibles.",
    "portal.not_linked": "Su cuenta aún no está vinculada a un expediente. Contacte a su oficial de cumplimiento.",
    "portal.documents": "Documentos",
    "portal.no_documents": "No hay documentos disponibles.",
    "portal.record": "Expediente",
    "portal.upload": "Enviar documento",
    "portal.upload_hint": "Suba documentos de actualización (identificación, referencias, soportes). El oficial de cumplimiento será notificado automáticamente. Máx. 1.5 MB.",
    "portal.uploaded": "Documento enviado. El oficial de cumplimiento fue notificado.",
    "portal.note": "Nota (opcional)",
    "nav.section.compliance": "Cumplimiento",
    "nav.risk": "Matriz de riesgo",
    "nav.employees": "Empleados (KYE)",
    "nav.suppliers": "Proveedores (KYP)",
    "nav.ros": "Reporte (ROS)",
    "nav.rte": "Transacciones efectivo",
    "nav.freeze": "Congelamiento CSNU",
    "nav.manual": "Control del manual",
    "k.level.bajo": "Bajo", "k.level.medio": "Medio", "k.level.alto": "Alto",
    "k.dd.simplificada": "DD Simplificada", "k.dd.estándar": "DD Estándar", "k.dd.ampliada": "DD Ampliada/Reforzada",
    "k.level": "Nivel de riesgo", "k.dd_level": "Nivel de DD",
    "k.last_verify": "Última verificación", "k.next_review": "Próxima revisión", "k.last_update": "Última actualización",
    "k.verified_match": "Coincidencia", "k.verified_clean": "Sin coincidencia", "k.pep_flag": "PEP",
    "k.factors": "Factores de riesgo", "k.factor": "Factor", "k.value": "Valor", "k.score": "Puntaje", "k.total": "Total",
    "k.reverify": "Re-verificar", "k.reverified": "Verificación actualizada",
    "k.deleted": "Registro eliminado", "k.delete_confirm": "¿Eliminar este expediente?",
    "k.public_title": "Registro de empleado — Conocimiento del Empleado (KYE)",
    "k.public_sub": "Complete sus datos y adjunte sus documentos. Su información será verificada en listas restrictivas.",
    "k.attachments": "Documentos adjuntos", "k.add_attachment": "Agregar", "k.filename": "Nombre del archivo",
    "k.note": "Nota", "k.file_optional": "Archivo opcional, máx. 1.5 MB", "k.att_added": "Documento agregado", "k.no_attachments": "Sin documentos",
    "k.clients": "Matriz de riesgo de clientes", "k.clients_sub": "Evaluación automática con 4 factores de riesgo y verificación en listas restrictivas al registrar cada cliente — Resolución S-037-2026 SSNF, Ley 23 de 2015, DE 35 de 2022",
    "k.employees": "Conocimiento del Empleado (KYE)", "k.employees_sub": "Registro de empleados con los mismos controles de debida diligencia aplicados a clientes, incluyendo verificación en listas restrictivas",
    "k.suppliers": "Debida diligencia a proveedores", "k.suppliers_sub": "Registro y verificación de proveedores con perfil, verificación en listas y nivel de riesgo asignado",
    "k.new_employee": "Registrar empleado", "k.new_supplier": "Registrar proveedor",
    "k.added": "Registro creado con verificación automática en listas",
    "e.name": "Nombre completo", "e.id_number": "Cédula o pasaporte", "e.position": "Cargo", "e.department": "Departamento",
    "e.hire_date": "Fecha de ingreso", "e.nationality": "Nacionalidad", "e.is_pep": "¿Es PEP?",
    "e.birth_date": "Fecha de nacimiento", "e.age": "Edad", "e.gender": "Género",
    "pf.col_role": "Rol", "pf.col_number": "No. consulta", "pf.col_query": "Consulta",
    "pf.col_type": "Tipo", "pf.col_result": "Resultado", "pf.col_form": "No. formulario", "pf.col_title": "Título",
    "pf.tab_info": "Información", "pf.tab_users": "Usuarios", "pf.tab_queries": "Consultas",
    "pf.tab_forms": "Formularios", "pf.tab_accesses": "Accesos", "pf.last_login": "Último acceso",
    "pf.link_target_org": "Organización destino", "pf.link_target_own": "Mi organización",
    "pf.reassign": "Reasignar a…", "pf.reassigned": "Registro reasignado",
    "nav.public_records": "Registros enlace público", "pr.title": "Registros de enlace público",
    "pr.sub": "Formularios recibidos mediante enlaces públicos, de todos los módulos y organizaciones",
    "pr.empty": "Sin registros de enlace público",
    "pr.module": "Módulo", "pr.org": "Organización", "pr.all": "Todos",
    "pr.export_pdf": "Exportar PDF", "pr.export_xlsx": "Exportar Excel",
    "pr.detail": "Detalle completo del registro", "pr.data": "Datos del formulario",
    "pr.resend": "Reenviar por correo", "pr.resent": "Correo enviado a la organización asignada",
    "e.gender.m": "Masculino", "e.gender.f": "Femenino", "e.gender.o": "Otro",
    "e.blood_type": "Tipo de sangre", "e.allergic": "¿Alérgico?", "e.allergy_detail": "Detalle de la alergia",
    "e.medical_conditions": "Padecimientos médicos", "e.photo": "Foto del empleado", "e.police_record": "Récord policivo",
    "s.legal_name": "Nombre o razón social", "s.tax_id": "RUC / NIT", "s.country": "País",
    "s.economic_sector": "Sector económico", "s.contact": "Persona de contacto", "s.phone": "Teléfono",
    "s.email": "Correo electrónico",
    "s.public_title": "Registro de proveedor — Conocimiento del Proveedor (KYP)",
    "s.public_sub": "Complete sus datos y adjunte sus documentos. Su información será verificada en listas restrictivas.",
    "ros.title": "Reporte de Operación Sospechosa (ROS)",
    "ros.subtitle": "Documentación de operaciones inusuales con examen especial y cadena lógica de monitoreo al reporte — Ley 23 de 2015",
    "ros.new": "Nuevo ROS", "ros.subject_name": "Nombre del sujeto", "ros.subject_id": "Documento de identidad",
    "ros.operation_desc": "Descripción de la operación", "ros.amount": "Monto", "ros.currency": "Moneda", "ros.channel": "Canal",
    "ros.detection_date": "Fecha de detección", "ros.unusual_reason": "Razón de inusualidad (tipología)",
    "ros.examen_notes": "Hallazgos del examen especial", "ros.examen_date": "Fecha del examen", "ros.decision": "Decisión",
    "ros.d_pending": "Pendiente", "ros.d_report": "Reportar a la UAF", "ros.d_archive": "Archivar",
    "ros.decision_date": "Fecha de decisión", "ros.uaf_reference": "Referencia reporte UAF", "ros.status": "Estado",
    "ros.st_en_analisis": "En análisis", "ros.st_reportado_uaf": "Reportado a UAF", "ros.st_archivado": "Archivado",
    "ros.saved": "ROS registrado", "ros.updated": "ROS actualizado", "ros.edit": "Editar",
    "rte.title": "Transacciones en Efectivo y Cuasi-Efectivo (RTE)",
    "rte.subtitle": "Registro de transacciones en efectivo que superen el umbral aplicable — Ley 23 de 2015 / Ley 124 de 2020",
    "rte.new": "Nuevo RTE", "rte.client_name": "Nombre del cliente", "rte.client_id": "Documento de identidad",
    "rte.tx_date": "Fecha de la transacción", "rte.cash_type": "Tipo de transacción",
    "rte.ct_cash": "Efectivo", "rte.ct_cashier": "Cheque de caja", "rte.ct_money_order": "Money order", "rte.ct_other": "Otro cuasi-efectivo",
    "rte.threshold": "Umbral aplicable (USD)", "rte.origin": "Origen de los fondos", "rte.destination": "Destino de los fondos",
    "rte.exceeded": "Supera umbral", "rte.below": "Bajo umbral", "rte.saved": "RTE registrado",
    "fz.title": "Congelamiento preventivo — Lista CSNU",
    "fz.subtitle": "Registro automático de casos al consultar la lista del Consejo de Seguridad de la ONU — Resolución S-037-2026 SSNF",
    "fz.case": "Caso", "fz.query": "Consultado", "fz.matched": "Coincidencias CSNU", "fz.action": "Acción tomada",
    "fz.notes": "Notas / documentación", "fz.action_date": "Fecha de la acción", "fz.status": "Estado",
    "fz.open": "Abierto", "fz.documented": "Documentado", "fz.closed": "Cerrado",
    "fz.update": "Registrar acción", "fz.updated": "Caso actualizado", "fz.activated": "Congelamiento activado", "fz.no_match": "Sin coincidencia",
    "fz.add": "Agregar caso", "fz.created": "Caso creado", "fz.deleted": "Caso eliminado",
    "fz.delete_confirm": "¿Eliminar este caso de congelamiento?",
    "fz.ev_deteccion": "Detección de coincidencia", "fz.ev_inmovilizacion": "Inmovilización inmediata",
    "fz.ev_reporte": "Reporte a la autoridad", "fz.ev_confidencialidad": "Confidencialidad",
    "mc.title": "Control de cambios del manual", "mc.subtitle": "Registro de cada modificación del manual de cumplimiento con versión, fecha y aprobación",
    "mc.new": "Registrar cambio", "mc.version": "Versión", "mc.section": "Sección modificada", "mc.description": "Descripción del cambio",
    "mc.approver_name": "Nombre de quien aprobó", "mc.approver_position": "Cargo de quien aprobó", "mc.saved": "Cambio registrado",
    "nav.settings": "Configuración",
    "st.title": "Configuración del tenant", "st.subtitle": "Parámetros de alertas y notificaciones de su organización",
    "st.name": "Nombre de la organización",
    "st.name_help": "Se muestra en el encabezado, reportes y documentos PDF.",
    "st.logo": "Logo de la empresa",
    "st.logo_change": "Subir / cambiar logo",
    "st.logo_help": "PNG, JPG o WebP, máx. 100 KB. Se muestra en el panel, encabezado y reportes PDF.",
    "st.logo_error": "El logo debe ser una imagen de máx. 100 KB",
    "st.alert_email": "Correo para alertas automáticas",
    "st.alert_email_help": "Recibirá alertas ante coincidencias en listas restrictivas, registros con nivel de riesgo alto y operaciones inusuales (ROS).",
    "st.id_prefix": "Iniciales del ID de cliente",
    "st.id_prefix_help": "Prefijo de 2 a 8 caracteres para el identificador hexadecimal de registros (ej. SOL-3F9A1B2C4D5E). Se deriva del nombre de la empresa si se deja vacío.",
    "st.saved": "Configuración guardada",
    "st.log": "Registro de alertas enviadas",
    "st.legal": "Cumplimiento con la Resolución No. S-037-2026 de la SSNF de Panamá, Ley 23 de 2015, Ley 124 de 2020 y Decreto Ejecutivo 35 de 2022.",
  },
  en: {
    "brand.name": "KYCFEDERAL",
    "brand.tagline": "Identity Verification Solutions",
    "nav.dashboard": "Dashboard",
    "nav.sanctions": "OFAC-UN-FATF",
    "nav.pep": "PEP & RCA",
    "nav.blacklist": "Private Blacklist (BL)",
    "bl.title": "Blacklist (BL)",
    "bl.clear_sel": "Clear selection",
    "bl.photo": "Subject photo", "bl.doc_cedula": "ID card", "bl.doc_pasaporte": "Passport", "bl.doc_licencia": "Driver license",
    "bl.upload_ph": "Choose file…",
    "bl.subtitle": "Natural persons, companies and suppliers blocked or restricted by your organization. Automatically screened in every due diligence search, just like the OFAC and UNSC lists.",
    "bl.new": "Add record", "bl.type": "Type",
    "bl.t_person": "Natural person", "bl.t_company": "Company", "bl.t_supplier": "Supplier",
    "bl.name": "Full name or business name", "bl.id_number": "ID card or passport", "bl.ruc": "Tax ID (RUC)",
    "bl.directors": "Linked directors", "bl.dir_name": "Name", "bl.dir_id": "ID card or passport", "bl.dir_position": "Position",
    "bl.reason": "Blocking reason", "bl.inclusion_date": "Inclusion date",
    "bl.status": "Status", "bl.active": "Active", "bl.inactive": "Inactive",
    "bl.registered_by": "Registered by", "bl.updated_by": "Updated by",
    "bl.deactivate": "Deactivate", "bl.activate": "Activate", "bl.edit": "Edit",
    "bl.saved": "Record added to blacklist", "bl.updated": "Record updated",
    "bl.search_ph": "Search blacklist…", "bl.documents": "Supporting documents",
    "nav.forms": "DD Forms",
    "nav.dd_natural": "Natural Person DD",
    "nav.dd_juridica": "Legal Entity DD",
    "nav.declaracion": "Source of Funds Declaration",
    "nav.certificacion": "Beneficial Owner",
    "nav.pep_panama": "Panama PEP List",
    "pp.title": "Panama PEP List",
    "pp.subtitle": "Politically Exposed Persons of the Republic of Panama. List managed by the super administrator; automatically checked in every PEP search.",
    "pp.add": "Add record", "pp.edit": "Edit record", "pp.import": "Import Excel",
    "pp.source_ph": "Source (e.g. National Assembly)",
    "pp.col_budget": "Budget line", "pp.col_salary": "Salary",
    "pp.template": "Download template",
    "pp.bulk_delete": "Bulk delete", "pp.bulk_scope": "Deletion scope",
    "pp.bulk_scope_all": "— Entire list —",
    "pp.bulk_warn": "All records in the selected scope will be permanently deleted. This action cannot be undone.",
    "pp.bulk_confirm": "Delete records", "pp.bulk_deleted": "records deleted",
    "pp.cargo_all": "All positions", "pp.cargo_diputados": "Deputies",
    "pp.cargo_ministros": "Ministers", "pp.cargo_viceministros": "Vice-ministers",
    "pp.cargo_directores": "Directors", "pp.cargo_jefes": "Chiefs",
    "pp.cargo_administradores": "Administrators",
    "pp.empty_prompt": "Run a search to view the list records.",
    "pp.clear_sel": "Clear selection",
    "pp.search_ph": "Search by name, ID, position or institution",
    "pp.col_name": "Full name", "pp.col_id": "ID / Passport", "pp.col_position": "Position",
    "pp.col_institution": "Institution", "pp.col_organ": "State branch", "pp.col_period": "Period",
    "pp.col_obs": "Observations", "pp.current": "Active", "pp.empty": "No records in the list",
    "pp.confirm_delete": "Delete this record from the Panama PEP List?",
    "pp.imported": "records imported", "pp.saved": "Record saved", "pp.deleted": "Record deleted",
    "pp.f_start": "Position start date", "pp.f_end": "Position end date",
    "pp.f_current": "Currently in office (active)",
    "pp.badge": "Panama PEP List",
    "nav.dd_aseguradora": "Insurer DD (Natural Person)",
    "a.title": "DD Natural Person — Insurer",
    "a.subtitle": "BC/FT/FPADM compliance form per Agreement No. 3 of November 22, 2022. Generic document, reusable by any insurer.",
    "a.sec0": "Person completing", "a.sec1": "General data", "a.sec2": "Politically Exposed Person (PEP)",
    "a.sec3": "Financial profile", "a.sec4": "Employment data", "a.sec5": "Consent",
    "a.sec6": "Signatures", "a.sec7": "Required documents",
    "a.completed_by": "The person completing this form is (multiple selection):",
    "a.cb_contractor": "Policyholder", "a.cb_insured": "Insured", "a.cb_broker": "Broker",
    "a.cb_payer": "Payer", "a.cb_insurer": "Insurance Co.", "a.cb_beneficiary": "Beneficiary",
    "a.last_name_p": "Last name (1st)", "a.last_name_m": "Last name (2nd)",
    "a.first_name": "First name", "a.second_name": "Middle name",
    "a.birth_date": "Date of birth", "a.birth_country": "Country of birth",
    "a.nationality": "Nationality", "a.residence_country": "Country of residence", "a.gender": "Gender",
    "a.id_number": "National ID", "a.passport": "Passport",
    "a.addr_res": "Residential address", "a.addr_work": "Work address",
    "a.addr_country": "Country", "a.addr_province": "Province", "a.addr_district": "District",
    "a.addr_corregimiento": "Corregimiento", "a.addr_urb": "Neighborhood", "a.addr_street": "Street",
    "a.addr_building": "Building name", "a.addr_apt": "Apartment or house #",
    "a.mobile": "Mobile", "a.home_phone": "Home phone", "a.email": "Email",
    "a.tax_places": "Place(s) where you pay taxes on your income", "a.nit": "Tax identification number (NIT)",
    "a.is_pep": "Are you a PEP?", "a.pep_position": "Current or former position",
    "a.is_pep_relative": "Are you a relative of a PEP?", "a.is_pep_collab": "Are you a close collaborator of a PEP?",
    "a.pep_name": "PEP name", "a.pep_rel_position": "PEP position", "a.pep_relation": "Relationship with the PEP",
    "a.annual_income": "Approximate annual income (balboas)",
    "a.r1": "Less than 10k", "a.r2": "10k to 30k", "a.r3": "30k to 50k", "a.r4": "More than 50k",
    "a.other_income_desc": "If you earn income from another activity — description",
    "a.other_income_amount": "Approximate amount from the other activity",
    "a.profession": "Profession", "a.occupation": "Occupation", "a.employer": "Company name",
    "a.independent": "If self-employed or a merchant: description of the activity",
    "a.consent": "I, as the signatory, grant my consent so that, whenever necessary and required, the parties of the contractual relationship may access, use, share, process and/or custody my personal and sensitive data, including images of my personal identity documents, for purposes related to commercial activities and financial services, for which I accept and acknowledge that all my personal data is protected by ARCO rights (Access, Rectification, Cancellation, Opposition and/or Portability) in compliance with the Insurance Law in force together with the Personal Data Protection Law and its Regulations in force in the Republic of Panama.",
    "a.sig_client": "Client data", "a.sig_broker": "Broker data",
    "a.sig_insurer": "For insurer use only",
    "a.sig_name": "Name", "a.sig_reviewer": "Name of the reviewing employee",
    "a.docs": "Copy of national ID or passport (legible and valid), and any other document requested by the Company.",
    "nav.pj_aseguradora": "Insurer DD (Legal Entity)",
    "aj.title": "DD Legal Entity — Insurer",
    "aj.subtitle": "BC/FT/FPADM compliance form per Agreement No. 3 of November 22, 2022. Generic document, reusable by any insurer.",
    "aj.sec1": "Company general data", "aj.sec2": "Directors and officers",
    "aj.sec3": "Shareholders / Ultimate beneficial owners", "aj.sec4": "Legal representative / Attorney-in-fact / Administrator",
    "aj.sec5": "Resident agent",
    "aj.legal_name": "Legal name", "aj.trade_name": "Trade name",
    "aj.ruc": "Taxpayer registry (RUC)", "aj.addr_phys": "Physical address",
    "aj.const_country": "Country of incorporation", "aj.const_date": "Date of incorporation",
    "aj.operating_countries": "Country where it operates", "aj.activity": "Business activity",
    "aj.phone": "Phone", "aj.website": "Website",
    "aj.col_name": "Full name", "aj.col_id": "ID number", "aj.col_birth": "Date of birth",
    "aj.col_address": "Address", "aj.col_position": "Position", "aj.col_nat": "Nationality",
    "aj.col_pct": "% ownership",
    "aj.sh_note": "List the principal partners with 10% or more ownership.",
    "aj.pep_intro": "Does any member of this company (directors, officers, legal representative, attorney-in-fact, partners, shareholders or ultimate beneficial owners) fall within the following classification?",
    "aj.r1": "Less than 50k", "aj.r2": "50k to 250k", "aj.r3": "250k to 500k",
    "aj.r4": "500k to 3M", "aj.r5": "3M to 5M", "aj.r6": "5M to 10M", "aj.r7": "More than 10M",
    "aj.doc1": "Copy of the Legal Representative's or Attorney-in-fact's national ID or passport (legible and valid).",
    "aj.doc2": "Copy of the Public Registry Certificate.",
    "aj.doc3": "Operation Notice (if applicable).",
    "aj.doc4": "Any other document requested by the Insurance Company.",
    "aj.footer": "Regulated and Supervised by the Superintendence of Insurance and Reinsurance of Panama",
    "pf.view_edit": "View / Edit",
    "pf.modules": "Modules enabled for this organization",
    "pf.all_modules": "All modules (unrestricted)",
    "pf.save_changes": "Save changes",
    "pf.detail_title": "Organization details",
    "pp.readonly_note": "Panama national PEP list (read-only). Managed by the super administrator.",
    "footer.last_login": "Last access",
    "ah.button": "Access history", "ah.title": "Access History",
    "ah.date": "Date & time", "ah.device": "Device / Browser",
    "ah.user": "User", "ah.tenant": "Organization",
    "ah.empty": "No access records", "ah.all_title": "Access history of all users",
    "ah.period": "View", "ah.mode_all": "All", "ah.mode_account": "By account", "ah.mode_day": "By day",
    "ah.mode_week": "By week", "ah.mode_month": "By month", "ah.week_start": "Week starting",
    "ah.month": "Month", "ah.from": "From", "ah.to": "To", "ah.export_pdf": "PDF",
    "ah.export_all": "Export all to PDF", "ah.accesses": "accesses",
    "nav.carta": "Release of Responsibility Letter",
    "nav.history": "History & reports",
    "nav.users": "Users & roles",
    "nav.logout": "Log out",
    "sec.title": "Security", "sec.devices": "Trusted devices", "sec.devices_help": "Devices where the verification code is not requested for 30 days.",
    "sec.device": "Browser / OS", "sec.added": "Added", "sec.last_used": "Last used", "sec.expires": "Expires", "sec.revoke": "Revoke", "sec.revoke_all": "Revoke all",
    "sec.none": "No active trusted devices.", "sec.revoked": "Device revoked", "sec.revoked_all": "All devices were revoked", "sec.this_device": "This device",
    "pw.change": "Change password",
    "pw.current": "Current password",
    "pw.new": "New password",
    "pw.confirm": "Confirm new password",
    "pw.mismatch": "New passwords do not match",
    "pw.success": "Password updated successfully",
    "nav.section.main": "Main",
    "nav.section.screening": "Screening",
    "nav.section.forms": "Due diligence",
    "nav.section.admin": "Administration",
    "osint.title": "OSINT search (open sources)", "osint.subtitle_for": "Direct search links for:",
    "osint.subtitle_empty": "Type a name in the main search field to generate the links automatically.",
    "osint.pdf": "Generate PDF",
    "osint.reviewed": "Mark as reviewed", "osint.reviewed_count": "reviewed", "osint.finding_ph": "Finding in this source (optional)",
    "osint.notes": "OSINT evidence notes", "osint.notes_ph": "Summary of findings, discarded matches, screenshots obtained…",
    "osint.save": "Save evidence", "osint.saved": "OSINT evidence saved to the consult", "osint.attach": "Attach to file",
    "osint.attached": "PDF report attached to the file", "osint.pick_exp": "Select file…",
    "nav.cyber": "Cyber Agency", "cy.title": "Cyber Agency", "nav.ntas": "NTAS Alerts",
    "nt.title": "NTAS Terrorism Alerts", "nt.subtitle": "National Terrorism Advisory System (DHS, USA) — active alerts and history; automatic superadmin notification on new alerts",
    "nt.refresh": "Sync now", "nt.active": "Active", "nt.expired": "History (expired)", "nt.history": "Alerts recorded", "nt.last_sync": "Last sync",
    "nt.none_active": "No active alerts", "nt.none_active_long": "DHS has no active NTAS alerts or bulletins at this time.", "nt.empty": "No alerts recorded",
    "nt.pdf_active": "PDF active alerts", "nt.issued": "Issued", "nt.expires": "Expires",
    "cy.suppliers_title": "Suppliers (KYP) with exposed software", "cy.suppliers_none": "No registered supplier matches KEV vendors/products.", "cy.suppliers_checked": "suppliers checked",
    "cy.ntas_card": "NTAS Terrorism Alerts (DHS)", "cy.ntas_open": "Open module", "k.osint_summary": "Attached OSINT evidence",
    "th.title": "Threat panel", "th.since": "Last week since", "th.ntas": "Active NTAS alerts (DHS)", "th.kev": "New vulnerabilities (CISA KEV)", "th.total_week": "Week total", "th.suppliers": "Exposed suppliers", "k.intel_summary": "Attached intelligence reports (OSINT / CISA KEV / NTAS)",
    "cy.subtitle": "CISA Known Exploited Vulnerabilities catalog — search, filter and report for due diligence files",
    "cy.refresh": "Refresh catalog", "cy.catalog_total": "Catalog total", "cy.critical": "Critical", "cy.high": "High", "cy.released": "CISA release", "cy.results": "Results",
    "cy.search": "Software / Vendor / CVE", "cy.search_ph": "E.g. Microsoft, Cisco, Chrome, CVE-2026-…", "cy.severity": "Severity", "cy.from": "Added from", "cy.to": "Added to",
    "cy.selected": "selected", "cy.pdf": "PDF of selected", "cy.cve": "CVE ID", "cy.software": "Affected software", "cy.name": "Vulnerability", "cy.description": "Description",
    "cy.exploit_date": "Known exploitation", "cy.action": "Required action", "cy.due": "Due date", "cy.ransomware": "Ransomware use", "cy.empty": "No vulnerabilities for the given filters",
    "search.missing_date": "Missing since", "search.state_country": "State/Country", "search.age": "Age", "search.gender": "Gender",
    "nav.section.platform": "Platform", "sw.title": "Active organization", "sw.none": "Platform (no organization)",
    "sw.acting_as": "You now operate inside the selected organization with admin permissions", "sw.platform_mode": "Platform mode",
    "auth.login_title": "Sign in",
    "auth.register_title": "Create organization",
    "auth.email": "Email address",
    "auth.password": "Password",
    "auth.name": "Business type",
    "auth.company": "Organization name",
    "auth.login_btn": "Sign in",
    "auth.register_btn": "Create account",
    "auth.ruc": "Tax ID (RUC)",
    "auth.phone": "Phone",
    "auth.contact_person": "Contact person",
    "auth.logo": "Company logo",
    "auth.logo_hint": "PNG, JPG or PDF, max 1.3 MB. Shown in the panel.",
    "auth.logo_error": "Logo must be PNG, JPG or PDF up to 1.3 MB",
    "auth.subtitle": "KYC Platform — Due Diligence management and identity verification",
    "brand.ssnf": "Superintendency of Non-Financial Subjects of Panama",
    "auth.b1": "OFAC and UNSC lists updated every 24 hours",
    "auth.b2": "Digitally signed PDF reports",
    "auth.b3": "Official due diligence forms",
    "auth.version": "KYCFederal v6.1.8 2026",
    "auth.panama_time": "Panama time",
    "auth.otp_title": "Two-step verification", "auth.forgot_link": "Forgot your password?", "auth.forgot_title": "Reset password", "auth.forgot_help": "Enter your email and we'll send you a link valid for 1 hour.", "auth.forgot_btn": "Send link", "auth.forgot_sent": "If the email is registered, you will receive a link to reset your password. Check your spam folder too.", "auth.reset_title": "Create new password", "auth.reset_new": "New password (min. 8 characters)", "auth.reset_confirm": "Confirm new password", "auth.reset_btn": "Save password", "auth.reset_mismatch": "Passwords do not match.", "auth.reset_done": "Your password was updated. Trusted devices were revoked for security.",
    "rep.send": "Email report", "rep.title": "Send PDF report by email", "rep.help": "The full PDF of this verification will be sent as an attachment:", "rep.to": "Recipient email", "rep.confirm": "Confirm send", "rep.sent": "Report sent to",
    "pu.actions": "Actions", "pu.new_temp_password": "New temporary password", "pu.leave_blank": "Leave blank to keep current", "pu.create_sa": "Create Super Admin", "pu.sa_created": "Super administrator created. Credentials were emailed.", "pu.sa_help": "The new super administrator will have full access to the platform and all organizations. They will receive a welcome email with their access credentials.", "pu.title": "User management", "pu.create": "Create user", "pu.created": "User created. Welcome email sent.", "pu.temp_password": "Temporary password", "pu.send_credentials": "Include credentials in the welcome email", "pu.search_ph": "Search by name, email or organization…", "pu.activated": "User activated", "pu.deactivated": "User deactivated", "pu.edit_title": "Edit user", "pu.reset": "Send password reset", "pu.reset_sent": "Reset link sent to", "pu.delete_confirm": "Permanently delete this user? This action cannot be undone.",
    "pf.contacts_title": "Contact inbox", "pf.contacts_new": "new", "pf.contacts_all": "All", "pf.contacts_only_new": "Only new", "pf.contacts_handled": "Handled", "pf.contacts_mark_handled": "Mark handled", "pf.contacts_reopen": "Reopen", "pf.contacts_none": "No messages.", "pf.contacts_note": "Internal note (optional)", "auth.otp_remember": "Trust this device for 30 days (don't ask for a code here)", "auth.otp_help": "We sent a 6-digit code to", "auth.otp_verify": "Verify and sign in", "auth.otp_resend": "Resend code", "auth.otp_back": "Back", "auth.otp_expiry": "The code expires in 10 minutes. Maximum 5 attempts.", "auth.otp_resent": "A new code was sent to your email.",

    "auth.compliance": "Regulatory compliance",
    "common.search": "Search",
    "common.loading": "Loading…",
    "common.search": "Search",
    "common.save": "Save record",
    "common.saving": "Saving…",
    "common.cancel": "Cancel",
    "common.yes": "Yes",
    "common.no": "No",
    "common.other": "Other",
    "common.all": "All", "common.view": "View", "common.close": "Close",
    "common.actions": "Actions",
    "common.date": "Date",
    "common.user": "User",
    "common.type": "Type",
    "common.result": "Result",
    "common.download_pdf": "Download PDF",
    "common.download_excel": "Export Excel",
    "common.delete": "Delete",
    "common.add_row": "Add row",
    "common.export_pdf": "Export PDF",
    "common.optional": "optional",
    "common.client_id": "Client ID",
    "common.edit": "Edit",
    "common.deactivate": "Deactivate",
    "common.activate": "Activate", "common.refresh": "Refresh",
    "common.inactive": "Inactive",
    "frl.title": "Created records",
    "frl.search_ph": "Search by name or number…",
    "frl.status": "Status",
    "frl.st_active": "Active",
    "frl.st_inactive": "Inactive",
    "frl.st_all": "All",
    "frl.view": "View",
    "frl.detail": "Record detail",
    "frl.from": "From",
    "frl.to": "To",
    "frl.signature_done": "Signature on file",
    "frl.new": "New record",
    "vs.label": "Verification status",
    "vs.negativo": "Negative",
    "vs.falso_positivo": "False Positive",
    "vs.en_revision": "Under Review",
    "vs.positivo_confirmado": "Positive / Confirmed",
    "vs.d_negativo": "No matches on the list.",
    "vs.d_falso_positivo": "Name match dismissed using secondary data.",
    "vs.d_en_revision": "Partial match; investigation or documentary cross-check in progress.",
    "vs.d_positivo_confirmado": "Exact match confirmed with a sanctioned subject.",
    "vs.notes": "Additional information",
    "vs.notes_ph": "Relevant details or information…",
    "vs.saved": "Verification status updated",
    "nav.tv": "TV View",
    "tv.title": "Verification monitor",
    "tv.exit": "Exit",
    "tv.live": "LIVE",
    "tv.dbs": "Databases — update status",
    "tv.entries": "records",
    "tv.updated": "Updated",
    "tv.total": "Total screenings",
    "tv.positives": "Positives",
    "tv.negatives": "Negatives",
    "tv.today": "Today's screenings",
    "tv.recent": "Recent activity",
    "tv.positive": "POSITIVE",
    "tv.negative": "NEGATIVE",
    "tv.internal_bl": "Internal blacklist",
    "tv.internal_note": "Active records",
    "common.show_inactive": "Show inactive",
    "forms.updated": "Form updated successfully",
    "forms.attachments": "Required documents (max. 3 files of 1.5 MB)",
    "forms.max_files": "Maximum 3 files",
    "forms.public_link": "Public link",
    "forms.link_title": "Public registration link",
    "forms.link_help": "Share this link with your client or provider so they can complete the form and upload their documents without a user account. Both sides will receive an email notification on completion.",
    "forms.copy": "Copy",
    "forms.link_copied": "Link copied to clipboard",
    "forms.send_link": "Send",
    "forms.link_sent": "Link sent by email",
    "forms.revoke": "Revoke link",
    "forms.revoked": "Link revoked",
    "forms.uses": "submissions received",
    "forms.public_done": "Registration submitted successfully!",
    "forms.public_done_no": "Your document number is:",
    "forms.invalid_link": "This link is invalid or has been revoked. Please contact the organization.",
    "forms.qr_hint": "Scan this code to open the form on mobile. Ideal for front desk or printed documents.",
    "forms.qr_download": "Download QR",
    "vf.title": "Document verification",
    "vf.valid": "Authentic document",
    "vf.invalid": "Document not found or invalid",
    "vf.number": "Document number",
    "vf.type": "Document type",
    "vf.org": "Organization",
    "vf.date": "Issue date",
    "vf.seal": "Cryptographic seal (HMAC-SHA256)",
    "vf.hint": "Compare the number and seal with the presented PDF document.",
    "vf.kind_search": "Sanctions list screening",
    "vf.kind_pep": "PEP/RCA screening",
    "vf.kind_form": "Due diligence form",
    "vf.kind_ros": "Suspicious Operation Report (ROS)",
    "vf.kind_rte": "Cash Transaction Report (RTE)",
    "vf.kind_freeze": "UNSC preventive freezing",
    "dash.clients": "Clients",
    "dash.view_record": "View record",
    "dash.title": "Dashboard",
    "dash.welcome": "Your organization's activity overview",
    "dash.total_searches": "Screening queries",
    "dash.matches": "Matches",
    "dash.cleared": "Cleared",
    "dash.total_forms": "Forms registered",
    "dash.users": "Tenant users",
    "dash.month_by_source": "This month's queries by source", "dash.month_since": "Since", "tv.ntas_active": "active", "tv.ntas_hist": "in history",
    "pf.plan_all": "Full plan", "pf.plan_sources": "+ All sources", "pf.plan_no_sources": "− Remove sources", "pf.plan_basic": "Basic only",
    "dash.recent_searches": "Recent searches",
    "dash.recent_forms": "Recent forms",
    "dash.lists": "Sanctions lists status",
    "dash.no_data": "No records yet",
    "dash.view_detail": "View detail",
    "nav.fbi": "FBI Most Wanted", "nav.interpol": "INTERPOL", "nav.wb": "World Bank", "nav.osint": "OSINT search", "nav.namus": "NamUs 2.0", "nav.icmp": "ICMP Missing persons",
    "mod.fbi": "FBI Most Wanted", "mod.fbi_sub": "Search the FBI most wanted list (USA).",
    "mod.interpol": "INTERPOL — Red Notices", "mod.interpol_sub": "Live query of INTERPOL red notices.",
    "mod.wb": "World Bank — Debarred", "mod.wb_sub": "Firms and individuals debarred by the World Bank Group.",
    "mod.namus": "NamUs 2.0 — Missing persons", "mod.namus_sub": "Live query of the National Missing and Unidentified Persons System (USA).",
    "osint.open_for": "Open OSINT evidence for", "osint.module_title": "OSINT search", "osint.module_subtitle": "Direct links to open sources (Google, LinkedIn, X, Facebook, Pipl, TruePeopleSearch, Interpol, ICMP, MP Panama, NamUs) with evidence saved to the consult.",
    "osint.module_hint": "To save evidence and attach it to a file, first run the search in Sanctions lists and use the OSINT section of the result.",
    "icmp.title": "ICMP — Missing persons", "icmp.subtitle": "International Commission on Missing Persons — Online Inquiry Center. Search by country, gender and age.",
    "icmp.note": "ICMP has no name search: its database holds missing persons and unidentified remains, searchable by country, gender, age group and date. Links open the official finder with filters preloaded.",
    "icmp.link_pa": "Search missing persons — Panama (with filters)", "icmp.link_all": "ICMP finder — all countries", "icmp.link_report": "Report a missing person",
    "st.modules": "Enabled modules", "st.modules_help": "Enable or disable modules for the whole organization. Disabled modules disappear from the menu and their queries are blocked for all users.", "st.module_plan": "not in plan",
    "search.title": "OFAC-UN-FATF",
    "search.subtitle": "Individual and bulk screening against the official OFAC (SDN), UNSC (UN) and FATF lists.",
    "search.individual": "Individual search",
    "search.bulk": "Bulk search",
    "search.name_label": "Person or entity name",
    "search.name_ph": "E.g.: John Doe / Company Inc.",
    "search.type_label": "Type",
    "search.t_all": "All",
    "search.t_aircraft": "Aircraft",
    "search.t_entity": "Entity",
    "search.t_individual": "Individual",
    "search.t_vessel": "Vessel",
    "search.sources": "Sources",
    "search.run": "Screen",
    "search.running": "Screening…",
    "search.match": "MATCH FOUND",
    "search.no_match": "NO MATCH",
    "search.matches_found": "potential matches",
    "search.consult_no": "Query No.",
    "search.col_list": "List",
    "search.col_name": "Listed name",
    "search.col_type": "Type",
    "search.col_program": "Program / Regime",
    "search.col_ref": "Reference",
    "search.col_score": "Score",
    "search.alias": "Matched alias",
    "search.nationality": "Nationality",
    "search.dob": "DOB",
    "search.country": "Country",
    "search.grounds": "Grounds",
    "search.period": "Period",
    "search.ongoing": "Ongoing",
    "search.official_link": "Official record",
    "search.bulk_help": "Enter one name per line (max 500). Each name generates its own PDF report with a unique query number.",
    "search.bulk_run": "Screen all",
    "search.col_query": "Queried name",
    "search.col_matches": "Matches",
    "search.last_update": "Last update",
    "search.entries": "records",
    "search.refresh": "Refresh now",
    "search.refresh_started": "Refresh started in background",
    "search.status_ok": "Up to date",
    "search.status_error": "Error",
    "search.status_pending": "Pending",
    "search.auto_note": "Lists are automatically downloaded from official sources and updated every 24 hours.",
    "search.et_individual": "Individual", "search.et_person": "Individual",
    "search.et_entity": "Entity", "search.et_vessel": "Vessel",
    "search.et_aircraft": "Aircraft", "search.et_jurisdiction": "Jurisdiction",
    "search.person": "Person",
    "search.new": "New search",
    "search.pdf": "PDF", "search.excel": "Excel",
    "search.send_email": "Send by email",
    "search.email_sent": "Report emailed to",
    "search.entity": "Entity",
    "search.results": "Results",
    "p.title": "PEP / RCA Screening — OpenSanctions",
    "p.subtitle": "Politically Exposed Persons (PEP) and Risk & Corruption Associates (RCA) — OpenSanctions open database, automatically synced every 24 hours",
    "p.query_label": "Name, ID document or entity",
    "p.query_ph": "E.g.: Vladimir Putin / 8-888-888 / Company Inc.",
    "p.id_note": "Search by full name, alias, ID document number or entity name.",
    "p.category": "Category",
    "p.cat_all": "PEP and RCA",
    "p.found": "PEP/RCA FOUND",
    "p.col_category": "Category",
    "p.col_position": "Position / position source",
    "p.col_country": "Country",
    "p.col_since": "Listed since",
    "p.attribution": "Data from OpenSanctions (opensanctions.org) — CC BY-NC 4.0",
    "forms.save_success": "Form saved successfully",
    "forms.doc_no": "Document No.",
    "forms.signature": "Signature",
    "forms.sign_hint": "Sign inside the box with mouse or finger",
    "forms.clear": "Clear signature",
    "forms.sign_required": "You must sign the form before saving",
    "n.title": "Due Diligence — Natural Person",
    "n.subtitle": "New client registration or data update form",
    "n.sec1": "I. Personal data",
    "n.sec2": "II. Financial profile",
    "n.sec3": "III. PEP information",
    "n.sec4": "IV. Bank references",
    "n.sec5": "V. Commercial references",
    "n.sec6": "VI. Additional questions",
    "n.sec7": "VII. Client signature",
    "n.record_type": "Record type",
    "n.rt_new": "New client",
    "n.rt_update": "Data update",
    "n.first_name": "First name",
    "n.second_name": "Middle name",
    "n.last_name_p": "Paternal surname",
    "n.last_name_m": "Maternal surname",
    "n.last_name_c": "Married surname",
    "n.id_number": "ID card or passport",
    "n.birth_date": "Date of birth",
    "n.gender": "Gender",
    "n.gender_m": "Male",
    "n.gender_f": "Female",
    "n.gender_o": "Other",
    "n.nationality": "Nationality",
    "n.residence_country": "Country of residence",
    "n.marital_status": "Marital status",
    "n.ms_single": "Single",
    "n.ms_married": "Married",
    "n.ms_divorced": "Divorced",
    "n.ms_widowed": "Widowed",
    "n.birth_country": "Country of birth",
    "n.home_phone": "Home phone",
    "n.mobile": "Mobile number",
    "n.email": "Email",
    "n.po_box": "P.O. Box",
    "n.address": "Residential address",
    "n.employer": "Employer",
    "n.profession": "Profession",
    "n.work_phone": "Work phone",
    "n.position": "Position",
    "n.income_main": "Annual income — main activity",
    "n.income_other": "Annual income — other activities",
    "n.r1": "Less than $75,000",
    "n.r2": "$75,000 to $100,000",
    "n.r3": "$100,001 to $150,000",
    "n.r4": "More than $150,000",
    "n.payment_methods": "Preferred payment methods",
    "n.pm_check": "Check",
    "n.pm_cc": "Credit card",
    "n.pm_wire": "International wire transfer",
    "n.pm_ach": "ACH transfer",
    "n.pm_cash": "Cash",
    "n.pm_other": "Other",
    "n.payment_other": "Specify other payment method",
    "n.funds_origin": "Source of funds description",
    "n.is_pep": "Are you a politically exposed person (PEP)?",
    "n.pep_position": "Current position",
    "n.pep_date": "Position date",
    "n.is_pep_relative": "Are you a close relative of a PEP?",
    "n.pep_relative_name": "PEP relative full name",
    "n.bank": "Bank",
    "n.contact": "Contact person",
    "n.phone": "Phone",
    "n.legal_name_ref": "Name or business name",
    "n.dd_process": "Do you perform due diligence on clients and suppliers?",
    "n.dd_process_desc": "Process description",
    "n.investigated": "Has any employee, owner or executive been investigated for money laundering, corruption or criminal investigation?",
    "n.investigated_desc": "Explanation",
    "n.client_name": "Client name",
    "j.title": "Due Diligence — Legal Entity",
    "j.doc_aviso": "Operations Notice", "j.doc_registro_publico": "Public Registry",
    "j.doc_cedula": "ID card or Passport", "j.doc_ref_bancaria": "Bank Reference Letter",
    "j.subtitle": "Due diligence form for companies and legal entities",
    "j.sec1": "I. Company data",
    "j.sec2": "II. Directors and officers",
    "j.sec3": "III. Legal representative",
    "j.sec4": "IV. Main ultimate beneficiary",
    "j.sec5": "V. Representative PEP information",
    "j.sec6": "VI. Account conditions and payment methods",
    "j.sec7": "VII. Bank references",
    "j.sec8": "VIII. Commercial references",
    "j.sec9": "IX. Main clients",
    "j.sec10": "X. Main suppliers",
    "j.sec11": "XI. Additional questions",
    "j.sec12": "XII. Declaration and signature",
    "j.legal_name": "Legal name",
    "j.trade_name": "Trade name",
    "j.tax_id": "Tax ID (RUC/NIT)",
    "j.incorporation_country": "Country of incorporation",
    "j.economic_sector": "Economic sector",
    "j.products_services": "Products and services offered",
    "j.address": "Physical address",
    "j.phone": "Phone",
    "j.fax": "Fax",
    "j.website": "Website",
    "j.email": "Email",
    "j.registration_date": "Registration date",
    "j.branches": "Number of branches",
    "j.employees": "Number of employees",
    "j.full_name": "Full name",
    "j.id_number": "ID card or passport",
    "j.board_position": "Board position",
    "j.is_pep": "Is PEP?",
    "j.current_position": "Current position",
    "j.current_since": "Since (date)",
    "j.previous_position": "Previous position",
    "j.previous_until": "Until (date)",
    "j.rep_position": "Position",
    "j.rep_address": "Address",
    "j.rep_nationality": "Nationality",
    "j.rep_profession": "Profession",
    "j.ubo_name": "Full name",
    "j.ubo_phone": "Phone",
    "j.ubo_email": "Email",
    "j.ubo_pct": "Ownership percentage (%)",
    "j.rep_is_pep": "Is PEP?",
    "j.rep_pep_position": "Current position",
    "j.rep_pep_date": "Date",
    "j.rep_is_relative": "Close relative of a PEP?",
    "j.rep_relative_name": "Relative's name",
    "j.payment_methods": "Payment methods",
    "j.pm_credit_debit": "Credit / debit",
    "j.pm_wire": "Bank transfer",
    "j.funds_origin": "Source of funds description",
    "j.business_desc": "Business description",
    "j.position_col": "Position",
    "j.political": "Is the company linked to any political party?",
    "j.political_desc": "Details",
    "j.shareholders_other": "Do shareholders appear as owners of other businesses?",
    "j.shareholders_other_desc": "Details",
    "j.decl_text": "I declare that the information provided is true and complete, and I authorize its verification.",
    "j.rep_name_sign": "Legal representative or attorney-in-fact name",
    "j.signer_position": "Position",
    "d.title": "Source of Funds Declaration",
    "d.subtitle": "Sworn declaration of lawful source of funds",
    "d.declarant_name": "Declarant name",
    "d.id_number": "Identity document",
    "d.tax_id": "Tax ID (NIT/RUC)",
    "d.legal_representation": "Legal representation (if applicable)",
    "d.funds_origin": "Source of funds description",
    "d.lawful": "Lawful activity declaration",
    "d.lawful_default": "I declare under oath that the funds described come from lawful activities and are not related to money laundering, terrorism financing or any other illicit activity.",
    "d.client_name": "Client name",
    "cr.title": "Release of Responsibility Letter",
    "cr.subtitle": "Responsibility letter with credit line",
    "cr.name": "Declarant name",
    "cr.cip": "C.I.P. (personal ID number)",
    "cr.nationality": "Nationality",
    "cr.trade_name": "Commercial name or Business name",
    "cr.address": "Address",
    "cr.printed_name": "Printed name",
    "cr.nip": "N.I.P. (personal identification number)",
    "cr.preview_note": "The PDF is generated with the official letter format (title, addressee, body, signature and legal footer).",
    "cr.recipient_sec": "Recipient company",
    "cr.recipient_name": "Company name",
    "cr.recipient_dv": "DV (check digit)",
    "cr.recipient_ruc": "ConR.U.C.",
    "c.title": "Ultimate Beneficial Owner",
    "c.subtitle": "Official UBO record",
    "c.date": "Date",
    "c.signer_name": "Undersigned name",
    "c.signer_id": "ID / Passport",
    "c.capacity": "Capacity",
    "c.cap_president": "President",
    "c.cap_secretary": "Secretary",
    "c.cap_legal_rep": "Legal Representative",
    "c.cap_attorney": "Attorney-in-fact",
    "c.company_name": "Company name",
    "c.ubos": "Ultimate beneficial owners",
    "c.col_name": "Name",
    "c.col_id": "ID / Passport / Tax ID",
    "c.col_nat": "Nationality",
    "c.col_role": "Position or role in the company",
    "c.col_birth_addr": "Date of birth or physical address",
    "c.col_pct": "% Ownership",
    "c.col_public": "Public figure / position / period (or N/A)",
    "c.pct_total": "Total ownership",
    "c.pct_warn": "Ownership percentages do not add up to 100%",
    "c.rep_name": "Representative name",
    "c.rep_position": "Representative position",
    "h.title": "History & reports",
    "h.subtitle": "Your organization's screenings and forms (last 7 days)",
    "h.clear_sel": "Clear selection",
    "h.q_ph": "Search by name…",
    "h.kind": "Module",
    "h.k_all": "All",
    "h.k_searches": "List screenings",
    "h.k_forms": "Forms",
    "h.r_all": "All results",
    "h.r_match": "With match",
    "h.r_no": "No match",
    "h.form_type": "Form type",
    "h.from": "From",
    "h.to": "To",
    "h.number": "Number",
    "h.name_title": "Name / Title",
    "h.module": "Module",
    "h.search": "List screening",
    "h.pep": "PEP/RCA screening",
    "h.k_pep": "PEP/RCA screenings",
    "h.empty": "No records found with the applied filters",
    "u.title": "Users & roles",
    "u.subtitle": "Manage your organization's users",
    "u.add": "New user",
    "u.name": "Name",
    "u.email": "Email",
    "u.role": "Role",
    "u.admin": "Administrator",
    "u.operator": "Operator",
    "u.status": "Status",
    "u.active": "Active",
    "u.inactive": "Inactive",
    "u.create_title": "Create user",
    "u.create": "Create",
    "u.only_admin": "Only administrators can manage users.",
    "u.deactivate": "Deactivate", "u.delete": "Delete", "u.deleted": "User permanently deleted",
    "u.cleanup": "Clean up TEST_ users", "u.cleanup_confirm": "Permanently delete the {n} test users (name TEST_ or email test_) of this organization?",
    "u.cleanup_done": "{n} test users deleted", "u.cleanup_none": "No test users in this organization",
    "u.delete_confirm": "Permanently delete user {email}? This action cannot be undone.",
    "sw.banner": "Operating as Super Administrator inside organization:",
    "sw.hint": "To see the full menu (modules, users & roles, settings) pick an organization in the \"Active organization\" selector in the top bar.",
    "u.activate": "Activate",
    "u.created": "User created successfully",
    "u.updated": "User updated",
    "u.new_password": "New password (leave empty to keep current)",
    "u.type": "Type",
    "u.platform_admin": "Platform admin",
    "u.tenant_client": "Tenant client",
    "u.notify_email": "Notification email",
    "u.notify_hint": "Receives a copy of tenant alerts",
    "u.duration": "Usage duration",
    "u.months": "Months",
    "u.days": "Days",
    "u.hours": "Hours",
    "u.expires": "Expires",
    "u.expired": "Expired",
    "u.no_limit": "No limit",
    "u.edit": "Edit",
    "u.cancel": "Cancel",
    "u.modules": "Enabled modules",
    "u.save": "Save changes",
    "u.duration_hint": "Empty = no limit. When editing, renews from today; 0/0/0 removes the limit.",
    "u.client": "Client",
    "u.provider": "Provider",
    "u.auditor": "Auditor",
    "u.superadmin": "Super Admin",
    "nav.platform": "Global platform",
    "pf.purge_btn": "Clean test orgs", "pf.purge_title": "Delete test organizations", "pf.purge_help": "Test organizations were auto-detected (TEST_, DemoCorp, Prueba, resend.dev). They will be moved to trash with users deactivated; you can restore them for 30 days before permanent deletion.", "pf.purge_none": "No test organizations.", "pf.users_short": "users", "pf.purge_confirm": "Move to trash", "pf.purge_ask": "Move {n} test organization(s) to trash? Their users will be deactivated.", "pf.purge_done": "{n} organization(s) moved to trash (30 days)",
    "pf.trash_btn": "Trash", "pf.trash_title": "Organizations trash", "pf.trash_help": "Deleted organizations stay here 30 days with all their data and users (deactivated). When the period ends the superadmin is notified; data is kept until they confirm permanent deletion with “Delete now”.", "pf.trash_none": "Trash is empty.", "pf.trash_since": "in trash since", "pf.trash_days_left": "days left", "pf.trash_restore": "Restore", "pf.trash_delete_now": "Delete now", "pf.trash_restored": "Organization {name} restored", "pf.trash_deleted": "Organization {name} permanently deleted", "pf.trash_delete_ask": "Permanently delete {name} and all its data? This cannot be undone.",
    "nav.vessels": "OFAC Vessel", "vs.title": "OFAC Vessel — Sanctioned vessels", "vs.subtitle": "Consolidated database of vessels sanctioned by OFAC and other authorities (FCDO, UANI, EU, ASO, MFAT, GAC, SECO, UN). Search by name, flag, vessel type or IMO number.",
    "vs.import_title": "Update list from Excel", "vs.import_help": "Format: sheet 'Base de Datos' with columns Buque, IMO, Año de construcción, Clase (tamaño), Bandera and one date column per list (OFAC, FCDO, UANI, EU, ASO, MFAT, GAC, SECO, UN). The file replaces the whole list.",
    "vs.import_btn": "Import Excel", "vs.import_confirm": "The current list will be fully replaced by the file content. Continue?", "vs.imported": "vessels imported", "vs.import_warn": "row(s) with warnings (invalid IMO)",
    "vs.last_import": "Last update", "vs.records": "records", "vs.total": "Vessels in database", "vs.flags": "Flags", "vs.types": "Vessel types",
    "vs.name": "Vessel name", "vs.name_ph": "E.g. ABRAU, ACE…", "vs.flag": "Flag", "vs.type": "Vessel type", "vs.any_list": "Any list", "vs.sanction_date": "Sanction date", "vs.program": "OFAC program / Lists", "vs.built": "Built", "vs.last_date": "Latest",
    "vs.results": "vessels found", "vs.showing": "showing", "vs.none": "No results for the given criteria.", "common.clear": "Clear", "vs.first_date": "First designation", "vs.last_date_full": "Latest designation", "vs.by_authority": "Designation by authority", "vs.not_listed": "Not listed", "vs.click_hint": "Click a row to open the full record and export it.",
    "pf.lookup_title": "Trace organization or user", "st.module_always": "always on", "pf.sync_title": "Source synchronization (automatic every 24 h)", "pf.sync_refresh": "Refresh status", "pf.sync_now": "Sync now:", "pf.sync_records": "records", "pf.sync_started": "Synchronization started in background; status will refresh in a few minutes.", "pf.lookup_help": "Searches all organizations (including pending, rejected, archived and trashed), users and the platform audit trail.", "pf.lookup_ph": "Organization name, email or user…", "pf.lookup_none": "No results for that criteria.", "pf.lookup_tenants": "Organizations", "pf.lookup_users": "Users", "pf.lookup_events": "Audit trail", "pf.lookup_in_selector": "Visible in Active organization selector", "pf.lookup_not_selector": "Not visible in selector (status)", "pf.lookup_in_trash": "In trash",

    "ah.query": "Query", "ah.type": "Type", "ah.type_login": "Login", "ah.type_action": "Action", "ah.filter_user": "Filter by user or email…", "ah.filter_org": "Filter by organization…", "ah.records": "records", "ah.not_queried": "Set the period and press Query to see the access and action history.",
    "pf.title": "Global platform",
    "pf.subtitle": "Tenant administration and global platform usage metrics.",
    "pf.new_tenant": "New organization",
    "pf.tenants": "Organizations",
    "pf.users": "Users",
    "pf.forms": "Forms",
    "pf.searches": "Searches",
    "pf.created": "Created",
    "pf.tenant_created": "Organization created successfully",
    "pf.stats_tenants": "Active organizations",
    "pf.stats_users": "Total users",
    "pf.stats_searches": "Searches performed",
    "pf.stats_forms": "Registered forms",
    "pf.stats_expedientes": "Records",
    "pf.stats_alerts": "Alerts logged",
    "pf.usage_title": "Monthly usage per organization (searches + forms)",
    "pf.pending": "Pending registration requests", "pf.pending_help": "Organizations registered from the portal awaiting approval. Approving activates the account and sends a welcome email to the administrator; rejecting notifies by email with the given reason.", "pf.requested_at": "Requested:", "pf.reject_optional": "Optional. E.g.: invalid RUC, incomplete information…",
    "pf.approve": "Approve",
    "pf.reject": "Reject",
    "pf.reject_reason": "Rejection reason (will be emailed to the applicant)",
    "pf.reject_confirm": "Confirm rejection",
    "pf.pending_status": "Pending",
    "pf.rejected": "Rejected",
    "pf.approved_msg": "Organization approved and notified by email",
    "pf.rejected_msg": "Request rejected and notified by email",
    "auth.pending_title": "Request submitted",
    "auth.pending_countdown": "Redirecting to home in {s} seconds", "auth.back_home": "Back to home",
    "auth.pending_msg": "Your organization has been registered and is pending approval by the platform administrator. You will receive a confirmation email with the access link.",
    "st.notify_matrix": "Notifications by alert type",
    "st.notify_matrix_help": "Enable or disable each notification type and set its recipient email (empty = general alerts email).",
    "st.nt_list_match": "Restrictive list matches (OFAC, UNSC, FATF, FBI, OpenSanctions)",
    "st.nt_blacklist_match": "Internal Blacklist matches",
    "st.nt_high_risk": "High-risk clients",
    "st.nt_ros": "Unusual operations (ROS)",
    "st.nt_freeze": "UNSC preventive freezing",
    "st.nt_expiry": "Due diligence expirations",
    "st.nt_portal_doc": "Documents uploaded from the client portal",
    "st.nt_email": "Recipient email (optional)",
    "u.linked_record": "Linked record",
    "u.no_link": "— Not linked —",
    "nav.portal": "My portal",
    "portal.title": "My portal",
    "portal.subtitle": "Status of your due diligence record and available documents.",
    "portal.not_linked": "Your account is not linked to a record yet. Contact your compliance officer.",
    "portal.documents": "Documents",
    "portal.no_documents": "No documents available.",
    "portal.record": "Record",
    "portal.upload": "Send document",
    "portal.upload_hint": "Upload update documents (ID, references, supporting files). The compliance officer will be notified automatically. Max. 1.5 MB.",
    "portal.uploaded": "Document sent. The compliance officer has been notified.",
    "portal.note": "Note (optional)",
    "nav.section.compliance": "Compliance",
    "nav.risk": "Risk matrix",
    "nav.employees": "Employees (KYE)",
    "nav.suppliers": "Suppliers (KYP)",
    "nav.ros": "Report (ROS)",
    "nav.rte": "Cash transactions",
    "nav.freeze": "UNSC freezing",
    "nav.manual": "Manual change log",
    "k.level.bajo": "Low", "k.level.medio": "Medium", "k.level.alto": "High",
    "k.dd.simplificada": "Simplified DD", "k.dd.estándar": "Standard DD", "k.dd.ampliada": "Enhanced DD",
    "k.level": "Risk level", "k.dd_level": "DD level",
    "k.last_verify": "Last verification", "k.next_review": "Next review", "k.last_update": "Last update",
    "k.verified_match": "Match", "k.verified_clean": "No match", "k.pep_flag": "PEP",
    "k.factors": "Risk factors", "k.factor": "Factor", "k.value": "Value", "k.score": "Score", "k.total": "Total",
    "k.reverify": "Re-verify", "k.reverified": "Verification updated",
    "k.deleted": "Record deleted", "k.delete_confirm": "Delete this file?",
    "k.public_title": "Employee registration — Know Your Employee (KYE)",
    "k.public_sub": "Fill in your details and attach your documents. Your information will be screened against sanctions lists.",
    "k.attachments": "Attachments", "k.add_attachment": "Add", "k.filename": "File name",
    "k.note": "Note", "k.file_optional": "Optional file, max 1.5 MB", "k.att_added": "Attachment added", "k.no_attachments": "No documents",
    "k.clients": "Client risk matrix", "k.clients_sub": "Automatic assessment with 4 risk factors and restrictive-list screening when registering each client — Resolution S-037-2026 SSNF, Law 23 of 2015, ED 35 of 2022",
    "k.employees": "Know Your Employee (KYE)", "k.employees_sub": "Employee registry with the same due diligence controls applied to clients, including restrictive-list screening",
    "k.suppliers": "Supplier due diligence", "k.suppliers_sub": "Supplier registry and screening with profile, list verification and assigned risk level",
    "k.new_employee": "Register employee", "k.new_supplier": "Register supplier",
    "k.added": "Record created with automatic list screening",
    "e.name": "Full name", "e.id_number": "ID card or passport", "e.position": "Position", "e.department": "Department",
    "e.hire_date": "Hire date", "e.nationality": "Nationality", "e.is_pep": "Is PEP?",
    "s.legal_name": "Name or business name", "s.tax_id": "Tax ID (RUC/NIT)", "s.country": "Country",
    "s.economic_sector": "Economic sector", "s.contact": "Contact person", "s.phone": "Phone",
    "s.email": "Email",
    "s.public_title": "Supplier registration — Know Your Provider (KYP)",
    "s.public_sub": "Fill in your details and attach your documents. Your information will be screened against sanctions lists.",
    "ros.title": "Suspicious Operation Report (ROS)",
    "ros.subtitle": "Documentation of unusual operations with special examination and monitoring logical chain — Law 23 of 2015",
    "ros.new": "New ROS", "ros.subject_name": "Subject name", "ros.subject_id": "ID document",
    "ros.operation_desc": "Operation description", "ros.amount": "Amount", "ros.currency": "Currency", "ros.channel": "Channel",
    "ros.detection_date": "Detection date", "ros.unusual_reason": "Unusualness rationale (typology)",
    "ros.examen_notes": "Special examination findings", "ros.examen_date": "Examination date", "ros.decision": "Decision",
    "ros.d_pending": "Pending", "ros.d_report": "Report to FIU (UAF)", "ros.d_archive": "Archive",
    "ros.decision_date": "Decision date", "ros.uaf_reference": "UAF report reference", "ros.status": "Status",
    "ros.st_en_analisis": "Under analysis", "ros.st_reportado_uaf": "Reported to UAF", "ros.st_archivado": "Archived",
    "e.birth_date": "Date of birth", "e.age": "Age", "e.gender": "Gender",
    "pf.col_role": "Role", "pf.col_number": "Query no.", "pf.col_query": "Query",
    "pf.col_type": "Type", "pf.col_result": "Result", "pf.col_form": "Form no.", "pf.col_title": "Title",
    "pf.tab_info": "Information", "pf.tab_users": "Users", "pf.tab_queries": "Queries",
    "pf.tab_forms": "Forms", "pf.tab_accesses": "Accesses", "pf.last_login": "Last login",
    "pf.link_target_org": "Target organization", "pf.link_target_own": "My organization",
    "pf.reassign": "Reassign to…", "pf.reassigned": "Record reassigned",
    "nav.public_records": "Public link records", "pr.title": "Public link records",
    "pr.sub": "Forms received through public links, across all modules and organizations",
    "pr.empty": "No public link records",
    "pr.module": "Module", "pr.org": "Organization", "pr.all": "All",
    "pr.export_pdf": "Export PDF", "pr.export_xlsx": "Export Excel",
    "pr.detail": "Full record details", "pr.data": "Form data",
    "pr.resend": "Resend by email", "pr.resent": "Email sent to the assigned organization",
    "e.gender.m": "Male", "e.gender.f": "Female", "e.gender.o": "Other",
    "e.blood_type": "Blood type", "e.allergic": "Allergies?", "e.allergy_detail": "Allergy details",
    "e.medical_conditions": "Medical conditions", "e.photo": "Employee photo", "e.police_record": "Police record",
    "ros.saved": "ROS saved", "ros.updated": "ROS updated", "ros.edit": "Edit",
    "rte.title": "Cash and Quasi-Cash Transactions (RTE)",
    "rte.subtitle": "Registry of cash transactions exceeding the applicable threshold — Law 23 of 2015 / Law 124 of 2020",
    "rte.new": "New RTE", "rte.client_name": "Client name", "rte.client_id": "ID document",
    "rte.tx_date": "Transaction date", "rte.cash_type": "Transaction type",
    "rte.ct_cash": "Cash", "rte.ct_cashier": "Cashier's check", "rte.ct_money_order": "Money order", "rte.ct_other": "Other quasi-cash",
    "rte.threshold": "Applicable threshold (USD)", "rte.origin": "Source of funds", "rte.destination": "Destination of funds",
    "rte.exceeded": "Exceeds threshold", "rte.below": "Below threshold", "rte.saved": "RTE saved",
    "fz.title": "Preventive freezing — UNSC List",
    "fz.subtitle": "Automatic case registry when screening the UN Security Council list — Resolution S-037-2026 SSNF",
    "fz.case": "Case", "fz.query": "Screened name", "fz.matched": "UNSC matches", "fz.action": "Action taken",
    "fz.notes": "Notes / documentation", "fz.action_date": "Action date", "fz.status": "Status",
    "fz.open": "Open", "fz.documented": "Documented", "fz.closed": "Closed",
    "fz.update": "Record action", "fz.updated": "Case updated", "fz.activated": "Freezing activated", "fz.no_match": "No match",
    "fz.add": "Add case", "fz.created": "Case created", "fz.deleted": "Case deleted",
    "fz.delete_confirm": "Delete this freezing case?",
    "fz.ev_deteccion": "Match detection", "fz.ev_inmovilizacion": "Immediate immobilization",
    "fz.ev_reporte": "Report to the authority", "fz.ev_confidencialidad": "Confidentiality",
    "mc.title": "Manual change control", "mc.subtitle": "Log of every compliance manual modification with version, date and approval",
    "mc.new": "Log change", "mc.version": "Version", "mc.section": "Modified section", "mc.description": "Change description",
    "mc.approver_name": "Approver name", "mc.approver_position": "Approver position", "mc.saved": "Change logged",
    "nav.settings": "Settings",
    "st.title": "Tenant settings", "st.subtitle": "Your organization's alert and notification parameters",
    "st.name": "Organization name",
    "st.name_help": "Shown in the header, reports and PDF documents.",
    "st.logo": "Company logo",
    "st.logo_change": "Upload / change logo",
    "st.logo_help": "PNG, JPG or WebP, max 100 KB. Shown in the panel, header and PDF reports.",
    "st.logo_error": "Logo must be an image of max 100 KB",
    "st.alert_email": "Automatic alerts email",
    "st.alert_email_help": "Receives alerts on restrictive-list matches, high-risk records and unusual operations (ROS).",
    "st.id_prefix": "Client ID initials",
    "st.id_prefix_help": "2-8 character prefix for the hexadecimal record identifier (e.g. SOL-3F9A1B2C4D5E). Derived from the company name if left empty.",
    "st.saved": "Settings saved",
    "st.log": "Sent alerts log",
    "st.legal": "In compliance with SSNF Panama Resolution No. S-037-2026, Law 23 of 2015, Law 124 of 2020 and Executive Decree 35 of 2022.",
  },
};

const LangCtx = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ec_lang") || "es");
  const setLang = (l) => {
    localStorage.setItem("ec_lang", l);
    setLangState(l);
    if (localStorage.getItem("ec_token")) api.patch("/auth/language", { lang: l }).catch(() => {});
  };
  const t = (key) => dict[lang][key] ?? dict.es[key] ?? key;
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    if (typeof iso === "string" && !iso.includes("T")) return iso;
    return new Intl.DateTimeFormat("es-PA", {
      timeZone: "America/Panama", day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}
